/**
 * @namespace Namespace, используемый в списках.
 */
window.QList = {};
/**
 * @namespace Namespace, используемый в формах.
 */
window.QForm = {};

window.aFormModel = {};

$.fn.qInitForm = function(oOptions) {
	return this.each(function()
	{
		new Q.FORM(this, oOptions);
	});
};

Q.FORM = function(mForm, oOptions)
{

	var $form = $(mForm);
	var sFormId = $form.attr("id");

	this.id = $form.find("input[name=id]").val();

	if(this.id) qdebuginfo("Открыта на редактирование запись с id IN ("+this.id +")");

	this.bModified = false;

	// Пригодится для обращения из jquery-callback'ов
	var oForm = this;

	//console.log("oOptions");
	//console.dir(oOptions);

	var oDefaults =
	{
		"bAdmin": false,
		"fnPreSubmit":
			function(/**{jQuery object}*/$form)
			{
				return this.fnPreSubmit_($form);
			},
		"fnBeforeSerialize":
			function(/**{jQuery object}*/$form, /**{Object}*/oOptions)
			{
				return this.fnBeforeSerialize_($form, oOptions);
			},
		"fnBeforeSubmit":
			function(/**{Object}*/oArr, /**{jQuery object}*/$form, /**{Object}*/oOptions)
			{
				return this.fnBeforeSubmit_(oArr, $form, oOptions)
			},
		"fnOnSuccess":
			function(mResponse, sStatusText, xhr, $wrappedForm)
			{
				return this.fnOnSuccess_(mResponse, sStatusText, xhr, $wrappedForm);
			},
		"fnBeforeInit":
			function($form, oOptions)
			{
				return this.fnBeforeInit_($form, oOptions);
			},
		"fnAfterInit":
			function($form, oOptions)
			{
				return this.fnAfterInit_($form, oOptions);
			},
		"mSendButtonSelector": null, //"#"+sFormId+" button.submitBtn",
		"mLoaderSelector": null, //"#"+sFormId+" div.loader",
		"sHelp": null,
		"keyHelp": null,
		"bHasTabs": false,
		"bAjaxSend": true,
		"bUpdateModal": true,
		"idEntry": 0,
		"bMultiple": false,
		"sEntity": "",
		"bToPrint": false,
		"bHideSaveButton":false,
		"bHideDoneButton":false,
		"bHideApplyButton":false,
		"bHideAddMoreButton":false,
		"bHideDblButton":false,
		"bHideEditButton":true,
		"bWarnUnsaved":true,
		"bMultipleEdit":0,
		"oExternVars": null,
		"sParentFileName": "",
		"bPreventDataLoss": true,
		"bUseHotKeys": true,
		"id":0,
		"ids":[],
		"oJavaScripts": {},
		"sMainButtonText":'Сохранить',
		"sApplyButtonText":'Применить',
		"sOnSaveText":'Сохранение прошло успешно!'
	};

	//$form.submit
	oOptions = jQuery.extend(oDefaults, oOptions);

	/**
	 * Задаем свойства
	 */
	this.fnPreSubmit = oOptions.fnPreSubmit;
	this.fnBeforeSerialize = oOptions.fnBeforeSerialize;
	this.fnBeforeSubmit = oOptions.fnBeforeSubmit;
	this.fnOnSuccess = oOptions.fnOnSuccess;
	this.fnBeforeInit = oOptions.fnBeforeInit;
	this.fnAfterInit = oOptions.fnAfterInit;

	this.$form = $form;
	this.bIsScrollable = $form.is(".q-form-scrollable");

	if(this.bIsScrollable)
	{
		this.bIsScrollable = true;
		this.$tabContent = $form.closest_descendent(".tab-scrollable-content")
	}

	this.$form.data("qform-ids", oOptions.ids);

	if(oOptions.mSendButtonSelector)
		this.$saveBtn = $(oOptions.mSendButtonSelector);
	else this.$saveBtn = null;

	if(oOptions.mLoaderSelector)
		this.$loader = $(oOptions.mLoaderSelector);
	else this.$loader = null;

	this.sEntity = oOptions.sEntity;
	this.bUpdateModal = oOptions.bUpdateModal;
	this.idEntry = oOptions.idEntry;
	this.bMultiple = oOptions.bMultiple;
	this.bMultipleEdit = oOptions.bMultipleEdit;

	this.bHasTabs = oOptions.bHasTabs;
	this.bAjaxSend = oOptions.bAjaxSend;

	this.bPreventDataLoss = oOptions.bPreventDataLoss;
	this.bUseHotKeys = oOptions.bUseHotKeys;

	this.sParentFileName = oOptions.sParentFileName;

	this.sFormId = sFormId;

	this.oExternVars = oOptions.oExternVars;

	this.id = oOptions.id;
	this.ids = oOptions.ids;

	this.oJavaScripts = oOptions.oJavaScripts;

	var sField;
	for(sField in this.oJavaScripts.oUpdateFunctions)
	{
		var sJavascript = this.oJavaScripts.oUpdateFunctions[sField];
		(function(){
			var bUpdate = false;
			eval(sJavascript);
		})();
	}


	$form.data("qform-object", this);


	// Вызовем преиницилизационный Callback
	this.fnBeforeInit($form, oOptions);
	/**
	 * Начало инициализации формы
	 */
	// Инициализируем табы
	//console.log("atat");
	// Перезапишем Submit
	//console.log("Form submit overloaded");
	$form.submit(function()
	{
		//console.log("form submitted!\n");
		oForm.fnSubmit();
		return false;

	});

	//В свою очередь сделаем так, чтобы форма по ENTER не сабмитилась…
	$form.on(($.browser.opera ? "keypress" : "keydown")
	,   'input.qfield-string'
	   +',input.qfield-int'
	   +',input.qfield-slider'
	   +',input.qfield-date'
	   +',input.qfield-datetime'
	   +',input.qfield-time'
	   +',input.qfield-double'
	   +',input.qfield-money'
	   +',input.qfield-combobox'
	   +',input.qfield-autocomplete'
	,  function(e)
	{
		if(e.keyCode == KEY.RETURN) return false;
	});

	//Зададим event на кнопку сохранения
	if(this.$saveBtn)
		this.$saveBtn.click(function()
		{
			//console.log("$saveBtn clicked");
			$form.submit();
			//
		});

    $form.find('.qform-maxLength').each(function()
    {
        var $this = $(this);
        if ($this.attr('maxlength') && $this.attr('maxlength')!='undefined')
        {

            $this.maxlength(
            {
                placement: 'best-one',
                alwaysShow: true, // if true the indicator it's always shown.
                threshold: 10, // Represents how many chars left are needed to show up the counter                    showCharsTyped: true, // show the number of characters typed and not the number of characters remaining
                validate: true // if the browser doesn't support the maxlength attribute, attempt to type more than
                                                                    // the indicated chars, will be prevented.
            });
        }
    });


    if(this.bMultipleEdit)
	{
		//alert("!!");

		QForm.processMultipleEditControls($form);
	}


	//console.log("oForm: %o", oForm);

	if(this.bPreventDataLoss)
	{
		// В случае, если было изменено хоть 1 поле в форме… уведомлять об изменениях
		this.oSavedValues = {};
		this.aChangedFields = []; // Массив всех полей, которые были изменены…
		$form.find('div.q-field input, div.q-field select, div.q-field textarea').each(function()
		{
			var $this = $(this);
			if($this.is('.speech_for_textarea')) return;
			var sName = $this.attr('id');
			if(typeof(sName) !== "undefined")
			{
				if($this.is(':checkbox'))
				{
					oForm.oSavedValues[sName] = $this.is(':checked');
				}
				else if($this.is(':radio'))
				{
					if(typeof(oForm.oSavedValues[sName])==='undefined') oForm.oSavedValues[sName] = false;
					if($this.is(':checked')) oForm.oSavedValues[sName] = $this.val();
				}
				else
				{
					oForm.oSavedValues[sName] = $this.val();
				}
			}

		});

		$form.on("keyup change blur updated", 'input, select, textarea', function(e)
		{
			var $field = $(e.target);
			if($field.is('.speech_for_textarea')) return;
			if(!$field.closest('.q-field').length) return;
			var sName = $field.attr('id');

			//console.log("Something going to happen! ",sName, oForm.oSavedValues[sName]);
			if(typeof(sName) !== "undefined")
			if(typeof(oForm.oSavedValues[sName])!=='undefined') // те поля, которых не было изначально, даже и не рассматриваем.
			{
				//console.log("What's the buzz?");
				var mValue;
				if($field.is(':checkbox'))
				{
					mValue = $field.is(':checked');
				}
				else if($field.is(':radio'))
				{
					if($field.is(':checked')) mValue = $field.val();
					else return;
				}
				else
				{
					mValue = $field.val();
				}

				var k = common.getElementKey(sName, oForm.aChangedFields);
				if(mValue !== oForm.oSavedValues[sName])
				{
					//console.log("Field, that was changed: %o %o",$field, $field.closest('.q-field'));
					if(k===false) oForm.aChangedFields[oForm.aChangedFields.length] = sName;

					//console.log("Field", sName, "have been changed to",mValue,". Original was:",oForm.oSavedValues[sName],".");
					//if(sName === undefined) //console.log("Undefined field: %o\nEvent: %o", $field, e);
				}
				else
				{
					if(k!==false) common.deleteElementByKey(k, oForm.aChangedFields);
					//console.log("Field", sName, "have been changed back to original value", oForm.oSavedValues[sName],".");
				}

				oForm.bModified = !!oForm.aChangedFields.length;
			}

		});

	}
	//console.log("this.oSavedValues: %o",this.oSavedValues);

	if(this.bUseHotKeys)
	{
		// Настроим горячие клавиши…
		// Специалиьно используем keypress, keydown — чтобы в комбинации с alt не вводились никакие символы, например в случае использования раскладки Бирмана.
		/****/
		var that = this;
		$('body').onFirst(($.browser.opera ? "keypress" : "keydown")+"."+$form.attr("id"), function(e)
		{
			//console.log("keypressed",$form.attr("id"));
			if( (
					e.keyCode=='S'.charCodeAt(0) || e.keyCode=='D'.charCodeAt(0) || (e.keyCode=='N'.charCodeAt(0) && e.shiftKey)|| (e.keyCode=='D'.charCodeAt(0) && e.shiftKey)
				    || (e.keyCode=='E'.charCodeAt(0) && e.ctrlKey)
			  	)
				&&
			 	(e.altKey || e.ctrlKey || e.metaKey)
			  )
			{
				e.stopPropagation();
				e.preventDefault();
				e.stopImmediatePropagation();

				if(!oOptions.bToPrint && !oOptions.bHideSaveButton && !oOptions.bHideDoneButton)
				{
					if(e.keyCode=='D'.charCodeAt(0) && !e.shiftKey) oForm.fnStoreFromModal(null, "done");
					else if(e.keyCode=='N'.charCodeAt(0) &&  e.altKey &&  e.shiftKey)  oForm.fnStoreFromModal(null, "save and create new");
					else if(e.keyCode=='D'.charCodeAt(0) &&  e.altKey &&  e.shiftKey) oForm.fnStoreFromModal(null, "save and duplicate");
					else /* if(e.keyCode=='S'.charCodeAt(0) && !e.shiftKey) */ oForm.fnStoreFromModal(null, "save");
					return false;
				}
			}
			if(oOptions.bToPrint)
			{
				if(e.keyCode=='E'.charCodeAt(0) && (e.ctrlKey || e.metaKey))
				{
					if(typeof(oForm.$extDialog)!=="undefined")
						if(oForm.$extDialog.length)
						{
							oForm.$extDialog.modal("hide");
							that.fnOpenToEdit();
						}
				}
			}
			if(e.keyCode=='W'.charCodeAt(0) && (e.altKey || e.ctrlKey || e.metaKey))
			{
				if(typeof(oForm.$extDialog)!=="undefined")
					if(oForm.$extDialog.length)
					{
						e.stopPropagation();
						e.preventDefault();
						e.stopImmediatePropagation();
						oForm.$extDialog.modal("hide");
						return false;
					}
			}

		});


		/****/

		$form.onFirst("destroyed", function()
		{
			//console.log("Form was destroyed", $form.attr("id"));
			$('body').off(($.browser.opera ? "keypress" : "keydown")+"."+$form.attr("id"));

		});

	}

	// Проверим, не находится ли форма в диалоге.
	if((this.$extDialog = this.$form.closest("div.modal-dialog")) != null)
	{
		//console.log("Form opened in dialog");
		// Если да, то указываем, что при ее закрытии надо произвести некоторые
		// действия…
		this.$extDialog.unbind('hide.bs.modal').on( "hide.bs.modal" , $.proxy(function(e)
		{
			if(!$(e.target).is(".modal-dialog")) return;

			if(oOptions.bWarnUnsaved && this.bModified)
			{
				var $focused = that.$form.find(":focus");
				//console.log("oForm.aChangedFields: %o",oForm.aChangedFields);
				var oButtons = {};
				oButtons["Не сохранять"] =
				{
					sClass:"btn-outline-danger btn-float-left",
					sShortcut: 'N',
					fnOnClick: function($btn, $Modal)
					{
						oForm.bModified = false;
						oForm.$extDialog.modal('hide');
						$Modal.modal('hide');
					}
				};
				oButtons["Сохранить"] =
				{
					sClass:"btn-outline-primary",
					sShortcut: 'Y',
					fnOnClick: function($btn, $Modal)
					{
						$Modal.modal('hide');
						oForm.fnStoreFromModal($btn, "done");
					}
				};
				oButtons["Отмена"] =
				{
					sClass:"btn-light",
					sShortcut: 'Esc',
					bFocused: true,
					fnOnClick: function($btn, $Modal)
					{

					}
				};

				var sMsg = '<h4>Хотите ли вы сохранить изменения, которые внесли в запись?</h4>'
					     + '<p>Сделанные изменения будут потеряны, если вы не сохраните их.</p>'
					    // + '<hr>'+oForm.aChangedFields.join(",")
					     ;

				Q.fnOpenModal(
				{
					sId: "QCloseFormConfirmBox",
					sClass: "modal-warning",
					sContent: sMsg,
					oButtons: oButtons,
					iMinWidth: 460,
					iMaxWidth: 580,
					fnOnOpen: function($Modal)
					{
						$('body').on(($.browser.opera ? "keypress" : "keydown")+'.closeconfirm', function(e)
						{
							if(e.keyCode=='N'.charCodeAt(0) && !e.altKey && !e.ctrlKey && !e.metaKey)
							{
								// #FIXME #DRY!
								oForm.bModified = false;
								oForm.$extDialog.modal('hide');
								$Modal.modal('hide');
							}
							if(e.keyCode=='Y'.charCodeAt(0) && !e.altKey && !e.ctrlKey && !e.metaKey)
							{
								// #FIXME #DRY!
								$Modal.modal('hide');
								oForm.fnStoreFromModal(null, "done");
							}
						});

						$Modal.on("destroyed", function()
						{
							$('body').off(($.browser.opera ? "keypress" : "keydown")+'.closeconfirm');
						});
					},
					fnOnClose: function($Modal)
					{
						$focused.focus();
					}
				} );
				return false;
			}

		}, this));

		//console.dir("Initializing…");
		//console.dir(oOptions);
		if(oOptions.bUpdateModal)
		{
			var that = this;
			this.$extDialog.on( "shown.bs.modal" , function()
			{

				//console.log("extDialog shown");

				that.fnInitTabs();

				// Так же, если есть, мы должны перенести в заголовок вопросик со справкой.
				//alert("11");
				var sTitle = that.$extDialog.find("form legend.qtext-title").html();
				//alert(sTitle);
				var $Title = $("<div>"+sTitle+"</div>");
				//alert($Title.html());
				var $HelpSign;
				if($HelpSign = $Title.find(".qform-help"))
				{
					// Чтобы не дублировать идентификатор (не хорошо, если будет два одинаковых dom id =)), добавим к нему постфикс
					var idDomHelpSign = $HelpSign.attr("id")+"_inModalHeader"
					$HelpSign.attr("id", idDomHelpSign);
				}
				else
					var idDomHelpSign = "";

				//alert("Strange place");

				// Заодно нарисуем кнопки
				var oButtons = {};

				if(!oOptions.bToPrint && !oOptions.bHideSaveButton)
				{


					//shift-pressed

					// body:not(.shift-pressed) .q-show-on-shift { display: none; }
					// body.shift-pressed .q-show-on-unshift { display: none; }

					//if(oOptions.idEntry=="0" && !oOptions.bMultiple) // только если мы создаем новую запись и если это не множественное создание
					if(!oOptions.bHideAddMoreButton && !oOptions.bHideDblButton)
					{
						oButtons["Сохранить и дублировать запись"] =
						{
							sClass:"btn btn-light btn-float-left q-show-on-shift saveAndCreateNewBtn",
							sShortcut: "Alt+Shift+D",
							bShortcutCellar: 1,
							bBold: 1,
							bHidden: 0,
							fnOnClick: function($btn, $Modal)
							{
								return that.fnStoreFromModal($btn, "save and duplicate");
							}
						}
					}

					if(!oOptions.bHideAddMoreButton)
					{
						if(!oOptions.bHideDblButton)
						{
							oButtons["Сохранить и создать новую запись"] =
							{
								sClass:"btn btn-light btn-float-left q-show-on-unshift saveAndCreateNewBtn",
								sShortcut: "Alt+Shift+N",
								sHint: "Нажмите с зажатым SHIFT, чтобы сохранить запись и открыть новую форму, \nзаполненную аналогичными данными",
								bShortcutCellar: 1,
								fnOnClick: function($btn, $Modal)
								{
									return that.fnStoreFromModal($btn, "save and create new");
								}
							}
						}
						else
						{
							oButtons["Сохранить и создать новую запись"] =
							{
								sClass:"btn btn-float-left",
								sShortcut: "Alt+Shift+N",
								sHint: "Сохранит текущую запись и откроет новую форму на создание",
								bShortcutCellar: 1,
								fnOnClick: function($btn, $Modal)
								{
									return that.fnStoreFromModal($btn, "save and create new");
								}
							}
						}
					}

					/***
					if(!oOptions.bMultipleEdit)
					{
						var sMainBtnText = (oOptions.idEntry!="0"?"Готово":"Создать");
					}
					else
					{
						var sMainBtnText = "Изменить "+get_correct_str(oOptions.ids.length, "запись", "записи", "записей");
					};
					***/
					if(!oOptions.bHideSaveButton && !oOptions.bHideDoneButton)
					{
						oButtons[oOptions.sMainButtonText] =
						{
							sClass:"btn-outline-primary DoneButton",
							sShortcut: (navigator.appVersion.indexOf("Mac")!=-1)?"⌘+D":"Ctrl+D",
							bShortcutCellar: 1,
							sHint: "Сохранить информацию и закрыть форму",
							fnOnClick: function($btn, $Modal)
							{
								return  that.fnStoreFromModal($btn, "done");
							}
						};
					}

					if(!oOptions.bHideApplyButton)
					{
						oButtons[oOptions.sApplyButtonText] =
						{
							sClass:"btn ApplyButton",
							sShortcut: (navigator.appVersion.indexOf("Mac")!=-1)?"⌘+S":"Ctrl+S",
							bShortcutCellar: 1,
							sHint: "Сохранить информацию и оставить форму открытой",
							fnOnClick: function($btn, $Modal)
							{
								return  that.fnStoreFromModal($btn, "save");
							}
						};
					};

					oButtons["Отмена"] =
					{
						sClass:"",
						sShortcut: "Alt+W / ESC",
						bShortcutCellar: 1,
						sHint:"Отменить все внесённые и закрыть форму",
						fnOnClick: function()
						{

						}
					};

				}
				else
				{
					if(!oOptions.bHideEditButton)
					{
						oButtons['Редактировать'] =
						{
							sClass:"btn btn-outline-primary btn-float-left",
							sIcon: "pencil",
							sShortcut: (navigator.appVersion.indexOf("Mac")!=-1)?"⌘+E":"Ctrl+E",
							bShortcutCellar: 1,
							sHint:"Открыть текущую форму на редактирование",

							fnOnClick: function($btn, $Modal)
							{
								that.fnOpenToEdit();
								return false;
							}
						}
					}

					oButtons["Закрыть"] =
					{
						sClass:"",
						sShortcut: "Alt+W / ESC",
						bShortcutCellar: 1,
						fnOnClick: function()
						{

						}
					};
				}


				Q.fnUpdateModalSettings(that.$extDialog, {sTitle: $Title.html(), oButtons: oButtons});

				if(idDomHelpSign)
					$("#"+idDomHelpSign).tooltip({ placement: "left", trigger:'hover click focus' });

				//return false; // Отдаем false чтобы предотвратить так называемы Event Bubbling — чтобы не вызывалось событие "shown" на детей, а именно — на табы.

			});
		};
	}
	else
	{
		this.fnInitTabs();
	}


	var that = this;

	// Инициализируем зелёные кнопки Сохранить на месте списков
	$form.on("click", ".qform-inline-save-btn", function(e)
	{
		//console.log("Inline save button pressed: %o", $(e.target));
		that.fnStoreFromModal($(e.target), "save"); // первым параметром передаём текущую кнопку
		e.stopPropagation();
		return false;
	});

	setTimeout(function()
	{
		// #FIXME DRY
		//var $focused = $(".initial-focusedinitial-focused");
		var $fields = that.$form.find("input, textarea, button.q-dropdown").filter(":visible").not(":disabled");
		//console.log("$fields: %o:", $fields);
		var $focused = $fields.filter(".initial-focused");
		//console.log("$focused: %o:", $focused);
		if($focused.length) $focused.first().focus();
		else $fields.first().focus();
		//e.stopPropagation(); // чтобы не вызывать событие shown для модального окна
	}, 300);

	/**
	 * Инициализация закончена, теперь вызываем callback
	 */
	this.fnAfterInit($form, oOptions);
};


Q.FORM.prototype.fnOpenToEdit = function()
{
	this.fnDim();

	QForm.fnOpenFormOnTab(this.$extDialog.find("ul.tabs2init .nav-link.active").closest("li").data("tab-name"), this.sEntity, this.id, this.oExternVars, null, "", this.sParentFileName);
	//// function ( oOptions, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, oOtherPostVars, iTab, bDublicate, fnOnClose)
}

/**
 * Накладывает некоторые модификации на табы — а именно делает так, чтобы в случае, если табы расположены в
 * несколько строк, при выборе закладки из не_нижней строки, строка с вкладкой перемещалась в самый низ.
 * Если табов у нас нет, то ничего не делает.
 *
 *
 * !!! Так же, (что очень важно!!!), предотвращает Event Bubbling, тем самым мы избежим вызова событий show и shown
 * для вышестоящего модального окна при открытии вкладок. !!!!
 *
 */
Q.FORM.prototype.fnInitTabs = function()
{

	var that = this;

	this.$tabsUl = that.$form.find("ul.nav-tabs");
	this.$tabs = that.$tabsUl.find("li");

	//alert("fnInitTabs");

	setTimeout(function()
	{

	// Теперь попробуем поработать с табами. Если они печатаются в несколько строк, то надо их разделить на классы:
	if(that.bHasTabs)
	{

		/**** Пока что отказались в пользу замены на подушки… ****/
		//that.fnProcessTabLines();
		//that.fnTabLineToBottom(that.$tabs.filter(".active"));

		that.fnProcessTabLines2();

		that.$tabs.on("show.bs.tab", function(e)
		{
			//console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
			that.fnTabLineToBottom($(this));
			e.stopPropagation(); // чтобы не вызывать событие show для модального окна
			//.eq(0).focus();

		});

		that.$tabs.on("shown.bs.tab", function(e)
		{
			//var $focused = $(".initial-focusedinitial-focused");
			var $fields = that.$form.find("input[type!=hidden]:visible, textarea:visible, div.q-dropdown button:visible").not("div.dataTables_filter input");
			//console.log("$fields: %o:", $fields);
			var $focused = $fields.filter(".initial-focused");
			//console.log("$focused: %o:", $focused);
			if($focused.length) $focused.first().focus();
			else $fields.first().focus();
			e.stopPropagation(); // чтобы не вызывать событие shown для модального окна
		});

		that.$tabs.bind('q_element_toggle', function()
		{
      		//console.log("q_element_toggle");
      		//that.fnProcessTabLines(true); /**** Пока что отказались в пользу замены на подушки… ****/
      		that.fnProcessTabLines2();
    	})

		/***/
	}

	if(that.bIsScrollable)
	{
		that.$tabContent.scrollspy({offset: 220});

		that.$tabs.on("shown.bs.tab", function(e)
		{
			// console.dir(e.target);
			var sSelector = e.target.hash;
			// console.log(sSelector+" - %o", $(sSelector));
			that.$tabContent.scrollTop(that.$tabContent.scrollTop() + $(sSelector).offset().top - 220);
		});

		// учтём conditions
		that.$form.on('shown.field hidden.field', (function()
		{
			// т.к. они могут приходить пачками за раз, будем их выполнять только после того,
			// как сработает последний (за 32 милисекунды)

			var rScrollTimeout = null; // статическая переменная
			return function()
			{
				if (rScrollTimeout)
				{
					clearTimeout(rScrollTimeout);
				}
				rScrollTimeout = setTimeout(function(){ that.$tabContent.scrollspy("refresh"); }, 32);
			}
		})());

	}

	}, 100);
}

Q.FORM.prototype.fnProcessTabLines2 = function()
{
	//alert(this.$tabsUl.outerHeight());
	// if(this.$tabsUl.outerHeight() > 45)
	// {
	// 	this.$tabsUl.addClass("nav-pills");
	// }
	// else
	// {
	// 	this.$tabsUl.removeClass("nav-pills");
	// }
}

Q.FORM.prototype.fnProcessTabLines = function(bRedraw)
{

	if(bRedraw === undefined) bRedraw = false;

	if(bRedraw)
	{
		this.$tabs.removeClass("tab-line-first-element");
		this.$tabs.each(function()
		{
			var $this = $(this);
			var iLine = $this.data("tab-line");
			$this.removeClass("tab-line-"+iLine);
		});
	}
	else
	{

	}

	var that = this;

	//console.log("processing tabs… foreach…");
	//alert(1);
	var iTopPosition_last = 0;
	var i = 0;
	that.$tabsUl = that.$form.find("ul.nav-tabs");
	that.$tabs = that.$tabsUl.find("li");
	//that.$tabs.filter(":hidden").addClass("where-hidden").show();
	//console.log("that.$tabs.find(\":hidden\"):"); //console.dir(that.$tabs.find(":hidden"));
	that.$tabs.each(function()
	{
		//console.log("#tab");
		var $this = $(this);
		var offset = $this.offset();
		//console.dir(offset);

		//console.log("iTopPosition_last="+iTopPosition_last+"\noffset.top="+offset.top);

		if($this.is(":visible"))
		{

			if(iTopPosition_last > offset.top+4 || iTopPosition_last < offset.top-4)
			{
				i++;
				iTopPosition_last = offset.top;
				$this.addClass("tab-line-first-element");
			}

		}

		$this.addClass("tab-line-"+i)
		     .data("tab-line",i);
	});
	//alert("!!");
	//that.$tabs.filter(".where-hidden").removeClass("where-hidden").hide();

//		if(i > 1)

	/***/

}

Q.FORM.prototype.fnTabLineToBottom = function($tabActive)
{

	var iTabLine = $tabActive.data("tab-line");
	var that = this;

	this.$tabs.each(function()
	{
		var $this = $(this);
		if($this.is(".tab-line-"+iTabLine))
			//… перемещаем в самый конец, чтобы в итоге все элементы оказались в нижней строке.
			$this.insertAfter(that.$tabsUl.find("li:last"));
	});
}

Q.FORM.prototype.fnUpdateTabsCounts = function(sTab)
{
	if(0)
	{
	if(typeof(sTab) == "undefined") sTab = "";
	// .. this.$form — текущая форма.
	var that = this;
	this.$tabs = that.$tabsUl.find("li");
	var sFormName = $(this.$form).data("qform-name");

	var id = $(this.$form).find("input[name=id]").val();
	this.$tabs.each(function()
	{
		var oTab = this;
		var tab_name    = $(this).data('tab-name');  //название вкладки
		var sUrl = "/q/"+sFormName + "/tab_colors/"+tab_name;

		$.ajax({
				type:'POST',
				dataype:'json',
				url:sUrl,
				data:
				{
				 	id: id
				},

				success: function(data)
				{
					if(!(typeof(data[1]) == "undefined"))
					{
						//console.log("Желтые " + tab_name + " =" + data[1]["value"]);
						if(data[1]["value"]==0)
						{
							$(oTab).find("a sup.badge.badge-control.badge-warning").css("display", "none");
						}
						else
						{
							if (!$(oTab).find("a sup.badge.badge-control.badge-warning").is(":visible"))
							{
								//console.log("Невидимый элемент (желтый)"+tab_name);
								$(oTab).find("a sup.badge.badge-control.badge-warning").css("display", "inline-block");
							}
							$(oTab).find("a sup.badge.badge-control.badge-warning").text(data[1]["value"]);
						}
					}
					if(!(typeof(data[-1]) == "undefined"))
					{
						//console.log("Красные " + tab_name + " =" + data[-1]["value"]);
						if(data[-1]["value"]==0)
						{
							$(oTab).find("a sup.badge.badge-control.badge-error").css("display", "none");
						}
						else
						{
							if (!$(oTab).find("a sup.badge.badge-control.badge-error").is(":visible"))
							{
								//console.log("Невидимый элемент (красный) должен стать видимым"+tab_name);
								$(oTab).find("a sup.badge.badge-control.badge-error").css("display", "inline-block");
							}
							$(oTab).find("a sup.badge.badge-control.badge-error").text(data[-1]["value"]);
						}
					}

				}

			})
	});

	console.log("fnUpdateTabsCounts");
	}
}

Q.FORM.prototype.fnStoreFromModal = function($btn, sAction, bForce, fnOnSuccess, fnOnFail)
{

	if(!this.bSavingIsInProgress)
	{
		if(sAction == undefined) sAction = "done";

		this.sSavingAction = sAction;

		var $Modal = this.$extDialog;
		if(typeof(bForce) == 'undefined') bForce = false;

		var sEntity = this.sEntity;
		var that = this;
		this.fnSubmit
		(
			// on complete callback
			function(mResponse, sStatusText, xhr, $wrappedForm)
			{

				if($btn !== null) $btn.buttonStopLoading();

				if(mResponse.success)
				{

					if(fnOnSuccess !== undefined) fnOnSuccess(mResponse, sStatusText, xhr, $wrappedForm);


					that.fnDim();
					that.bModified = false;
					// В этом случае that.bSavingIsInProgress убирать не надо, т.к. кнопки пока еще нажимать нельзя.
					switch(sAction)
					{
						case "done": $Modal.modal('hide'); break;
						case "save":
							QForm.fnOpenFormOnTab($Modal.find("ul.tabs2init .nav-link.active").closest("li").data("tab-name"), sEntity, mResponse.id, that.oExternVars, null, "", that.sParentFileName);
							//$AllButtons.filter(".DoneButton").text("Готово");
							break;
						case "save and create new":
							QForm.fnOpenFormOnTab(0, sEntity, 0, that.oExternVars, null, "", that.sParentFileName);
							//$AllButtons.filter(".DoneButton").text("Создать");
							break;
						case "save and duplicate":
							$Modal.modal('hide');
							QForm.fnOpenDublForm(sEntity, mResponse.id, that.oExternVars, null, "", that.sParentFileName);
							break;
					}
				}
				else
				{
					that.bSavingIsInProgress = false;

					if(fnOnFail !== undefined) fnOnFail(mResponse, sStatusText, xhr, $wrappedForm);

					//console.log('mResponse.warning: %o', mResponse.warning);
					if(!mResponse.warning) QForm.fnThrowStoreError(1);
					Q.fnUpdateModalSettings(that.$extDialog, {sTitle:"Ошибка при сохранении"});


				}
			},
			// beforeSubmit callback
			function(arr, $form, options)
			{
				that.bSavingIsInProgress = true;
				Q.fnUpdateModalSettings(that.$extDialog, {sTitle:"Сохраняю…"});
				if($btn !== null) $btn.data("loading-text","Сохраняю…").buttonStartLoading();
			},
			// beforeSerialize callback
			function($form, options)
			{

			},
			// bForce
			bForce
		);

	};

	return false;

}


Q.FORM.prototype.fnValidate = function()
{
	var $FirstMissingField;
	var iMissingFields = 0;
	var sFirstMissingFieldTabId = null;
	var oForm = this;

	var $activeElements = this.$form.find("div.active-element");

	var aMissingfields = [];
	$activeElements
		.find('input[required="1"], select[required="1"], textarea[required="1"]'
		  + ', input[required="required"], select[required="required"], textarea[required="required"]'
		)
		.each(function()
		{
			// Проверим, быть может у нас скрыт таб.
			if(oForm.$tabs !== undefined && oForm.$tabs.length)
			{
				var sTabId = $(this).closest(".tab-pane").attr("id");
				if(oForm.$tabs.find("a[href='#"+sTabId+"']").is(":hidden")) return; // continue;
			}

			if($(this).closest(".hidden-by-condition").length) return;//continue
			if($(this).closest(".field-hidden").length) return;//continue


			if(this.type=="hidden") return; // continue;
			if(this.type=="checkbox" || this.type=="radio")
			{
				var sCheckboxName = this.name; // ну еще и радиокнопка сюда же =)
				if(!$activeElements.find("input[name='"+this.name+"']:checked").length)
				{
					iMissingFields++;
					aMissingfields[aMissingfields.length] = sCheckboxName;
					$(this).addClass("attention");
					if(oForm.bHasTabs)
					{
						if(! sFirstMissingFieldTabId)
							sFirstMissingFieldTabId = $(this).closest(".tab-content > .tab-pane").attr("id");
					}

					if(! $FirstMissingField)
					{
						$FirstMissingField = $(this);
					}
				}
				else
				{
					$(this).removeClass("attention");
				}
			}
			if(empty($(this).val()))
			{
				iMissingFields++;
				$(this).addClass("attention");

				if(oForm.bHasTabs)
				{
					if(! sFirstMissingFieldTabId)
						sFirstMissingFieldTabId = $(this).closest(".tab-content > .tab-pane").attr("id");
				}

				if(! $FirstMissingField)
				{
					$FirstMissingField = $(this);
				}
			}
			else $(this).removeClass("attention");
			// console.log(this,$(this).hasClass("attention"));
		});


	var $tabs = this.$form.find("ul.nav-tabs > li > a");

	if(iMissingFields)
	{
		Q.fnAlertError("Заполните все поля, помеченные обязательными!", $.proxy(function()
		{
			if(this.bHasTabs) //this.$tabs.tabs( "select" , sFirstMissingFieldTabId );
			{
				$tabs.filter('[href="#'+sFirstMissingFieldTabId+'"]').tab("show");
			}
			$FirstMissingField.focus();

		},this));
		return false;
	}
	else
	{
		if(oForm.id == "0" || !oForm.id)
		{
			// Если все в порядке, то пробежимся по полям и запомним те, которые preserve.
			// #FIXME Не совсем правильное место для этого, конечно, но придется пока тут.
			console.log("Preserving fields…");
			$activeElements.find('input[data-preserve="1"], select[data-preserve="1"], textarea[data-preserve="1"]').each(function()
			{
				//console.log('Preserving for field="'+this.name+'"');

				QForm.fnProcessReversedField(this);
			});
		}
		return true;
	}
}

QForm.fnProcessReversedField = function(field)
{
	if(field.type == "hidden") return ; //continue

	if(field.type == "radio" && !$(field).is(":checked")) return;

	var sVal = $(field).val();
	if(field.type == "checkbox" && !$(field).is(":checked")) sVal = 0;

	var sPreserveName = $(field).data("preserve-name");
	var oOptions = {};
	if($(field).data("preserve-expires"))
		oOptions.expires = $(field).data("preserve-expires");
	oOptions.path = "/"; // Надо потом будет пересмотреть — дать возможность разработчикам самим выбирать "область видимости"

	$.cookie("ps_"+sPreserveName, sVal, oOptions);
}

Q.FORM.prototype.fnSubmit = function(fnOnCompleteCallback, fnBeforeSubmitCallback, fnBeforeSerializeCallback, bForce)
{

	if(typeof(bForce) === 'undefined') bForce = false;

	//alert(bForce?'forced':'normal');

	var sUrl = this.$form.prop("action");
	if(bForce) sUrl += ((sUrl.split("?").length>1)?'&':'?')+'q-force=1';

	//console.log("Q.FORM.prototype.fnSubmit\n"+this.fnPreSubmit(this.$form));
	if(this.fnPreSubmit(this.$form) !== false)
	{
		if(this.fnValidate())
		{

			// Получим массив измененных полей.
			// Он уже есть — this.aChangedFields — только в нем лежат DOM id полей
			// (так сделано для правильной работы с checkboxgroup и radiobutton)
			// Нам же нужно получить массив названий (field@name)
			var aChangedFieldNames = []; // ключ — имя поля, значение — имя поля
			for(var i=0; i<this.aChangedFields.length; i++)
			{
				var sFieldName = $("#"+this.aChangedFields[i]).attr("name");
				//if(!$.inArray(sFieldName, aChangedFieldNames))
					aChangedFieldNames[aChangedFieldNames.length] = sFieldName;
			}

			//console.log("aChangedFieldNames: %o", aChangedFieldNames);

			//console.log("form is valid!\nthis.bAjaxSend="+this.bAjaxSend);
			if(this.bAjaxSend)
			{
				var oForm = this;
				//var $form = oForm.$form;
				this.$form.ajaxSubmit(
				{
					url: sUrl,
					dataType: 'json',
					data: {"q_changed_fields": aChangedFieldNames.join(",")},
					beforeSerialize: function($form, options)
					{
						oForm.fnBeforeSerialize($form, options);
						if(!empty(fnBeforeSerializeCallback)) fnBeforeSerializeCallback($form, options);
						// исключим фильтры из отправки…
						$form.find("div.q-filter").find("input, select, textarea").attr("disabled", 1);
					},
					beforeSubmit: function(arr, $form, options)
					{
						// включим фиьльтры обратно.
						$form.find("div.q-filter").find("input, select, textarea").attr("disabled", 0).removeAttr("disabled");

						oForm.fnBeforeSubmit(arr, $form, options);
						if(!empty(fnBeforeSubmitCallback)) fnBeforeSubmitCallback(arr, $form, options);

						// Сделаем все поля формы (и саму форму) неактивными
						oForm.fnDim();
					},
					success: function(oResponse, sStatusText, xhr, $wrappedForm)
					{
						oForm.fnLight();
						oForm.fnOnSuccess(oResponse, sStatusText,
										  xhr, $wrappedForm);
						if(!empty(fnOnCompleteCallback)) fnOnCompleteCallback(oResponse);
					},
					error: function()
					{
						oForm.bSavingIsInProgress = false;
						oForm.fnLight();
						QForm.fnThrowStoreError(2);
					},
					complete: function()
					{
						if(oForm.$loader)
							oForm.$loader.hide();
					}
				});

				return true;
			}
			else
			{
				// Не знаю почему, но по-другому не получается
				document.forms[this.$form.attr("id")].submit();
				return true;
			}

		}
		else
			return false;
	}
	else
		return false;
};

/**
 * Делает все поля формы неактивными.
 */
Q.FORM.prototype.fnDim = function()
{
	this.$extDialog.find("div.modal-footer .btn").addClass("disabled");

	this.$form.addClass("processing-elements")
	var a$Inputs = this.$form.find("input,button,select,textarea");
	a$Inputs.filter(":disabled").addClass("was-disabled");
	a$Inputs.attr("disabled",1);
}

/**
 * Активирует все поля формы
 */
Q.FORM.prototype.fnLight = function()
{
	this.$extDialog.find("div.modal-footer .btn").removeClass("disabled").buttonStopLoading();

	this.$form.removeClass("processing-elements");
	var a$Inputs = this.$form.find("input,button,select,textarea");
	a$Inputs.not(".was-disabled").attr("disabled",0).removeAttr("disabled");
	a$Inputs.filter(".was-disabled").removeClass("was-disabled").attr("disabled",1);
}

Q.FORM.prototype.fnBeforeSerialize_ = function($form, options)
{
	/////$("input.qfield-autocomplete").each(function(){alert("autocomplete val:"+$(this).val())});
	return true;
};

Q.FORM.prototype.fnBeforeSubmit_ = function(arr, $form, options)
{
	//alert("fnBeforeSubmit_");
	//$("#QLoaderBox").dialog("open");

	return true;
};
/**
 * @TODO Отлавливать ошибки на разных этапах сохранения и закрывать лоайдер
 * и активизировать кнопку.
 */
Q.FORM.prototype.fnPreSubmit_ = function($form)
{
	if(this.$saveBtn)
	{
		if(this.$saveBtn.is(".ui-button"))
			this.$saveBtn.button( "disable" );
		else this.$saveBtn.attr("disabled", "disabled");
	}
	if(this.$loader)
		this.$loader.show();
	//else
		//Q.fnShowLoader("Подождите, идёт сохранение…");

	return true;
};
Q.FORM.prototype.fnOnSuccess_ = function(mResponse,sStatusText,xhr,$wrappedForm)
{

	if(mResponse.success) this.id = mResponse.id;

	if(!empty(mResponse.debug))
	{
		var oSqlStory = mResponse.debug; //$.parseJSON(mResponse.debug.split('::br::').join('\n'));
		//console.dir(oSqlStory);
		Q.debug.fnShowSqlStory(oSqlStory, "store", this.sEntity);
	}

	const oReloadSettings = {callback: null, resetPaging: false};
	fnUpdateAllDataTables(oReloadSettings); // _FIXME: временное решение, т.к. не могу найти, почему он не обновляет таблицу при сохранении

	if(!empty(mResponse.warning))
	{
		//alert("!!!");
		if(mResponse.warning.critical)
		{
			Q.fnAlertError(mResponse.warning.message);
		}
		else
		{
			//Q.fnAlert(mResponse.warning.message);
			//Q.fnConfirm(mResponse.warning.message);
			Q.fnConfirm(mResponse.warning.message, $.proxy(function($btn, $Modal)
			{
				$Modal.modal('hide');
				this.fnStoreFromModal($btn, this.sSavingAction, true);

			}, this), 'Продолжить', 'warning');
		}
	}

};

Q.FORM.prototype.fnBeforeInit_ = function($form, oOptions) {return true;};
Q.FORM.prototype.fnAfterInit_ = function($form, oOptions) {return true;};

/**
 * @param mElementNames — массив элементов, строка с названием элемента,
 *                        или строка с несколькими названиями элементов,
 *                        перечисленных без пробелов через запятую.
 */
QForm.fnUpdateElement = (function()
{
	// будем препятствовать множественному вызову одного и того же обновления (это сделано пока что в первую очередь для fieldset)
	// TODO надо доработать. Например, если мы вызываем обновление поля foo, а потом вызываем обновление полей foo и bar, то мы должны первое пропустить. Сейчас же будет выполнено два обновления. Но пока это не критично
	var oiTimers = {};
	return function($form, mElementNames, aFieldsToSend, sUrl)
	{
		clearTimeout(oiTimers[mElementNames]);

		oiTimers[mElementNames] = setTimeout($.proxy(function()
		{

			if(empty(mElementNames)) return false;  // TODO Exception!

			if(mElementNames instanceof Array)
			{
				//var sElementNames = mElementNames.join(",");
				var aElements2Update = mElementNames
			}
			else if(typeof(mElementNames) == 'string')
			{
				//var sElementNames = mElementNames;
				var aElements2Update = mElementNames.split(",");
			}
			else
			{
				//alert("Damn!");
				return false; // todo EXCEPTION!!
			}

					for(var i=0; i < aElements2Update.length; i++)
						aElements2Update[i] = aElements2Update[i].split(/^parent./).join("");

			var oForm = $form.data("qform-object");

			// У нас (оказывается) есть возможность обновлять при помощи JS
			if(oForm !== undefined)
			{
				var i;
				for(i in aElements2Update)
				{
					var sElement = aElements2Update[i];
					if(oForm.oJavaScripts.oUpdateFunctions[sElement])
					{

						(function(){
							var bUpdate = true;
							eval(oForm.oJavaScripts.oUpdateFunctions[sElement]);
						})();

						common.deleteElementByValue(sElement, aElements2Update);
					}
				}
			}

			if(!aElements2Update.length) return true;

			var i;
			for(i in aElements2Update)
			{
				$form.find(".qelement-name-"+aElements2Update[i]).addClass("processing-elements");
			}

			var aDataToSend = this._processAjaxVars($form, aFieldsToSend);
			var sFormName = $form.data("qform-name");


			var sWorkspace = (Q.WORKSPACE.length) ? "/"+Q.WORKSPACE : "";
			if(empty(sUrl)) sUrl = sWorkspace+"/q/"+sFormName+"/element/"+aElements2Update.join(",");

			$.ajax(sUrl,
			{
				type: "POST",
				data: aDataToSend,
				dataType: "html",
				success: function(sHtml4Elements)
				{
					//console.dir(sHtml);
					var aHtml = sHtml4Elements.split("<!--QFORM ELEMENT SEPARATOR-->");
					for(i in aHtml)
					{
						var sHtml = aHtml[i];
						if(sHtml.trim()=='') continue;

						var $html = $(sHtml);
						var sScript = $html.filter('script').html();

						var sDomId = $html.attr("id");
						var $new = $("#"+sDomId).replaceWith($html.not('script'));

						eval(sScript);

						$new.trigger("updated.field")
							.find('input,select,textarea')
							.trigger('updated.field');

						$("#"+sDomId).closest(".q-field, .q-filter").trigger('updated.field');

						//console.log("thrown updated.field event! %o",$("#"+sDomId));

						if(oForm != undefined && oForm.bIsScrollable) // Дело в том, что данная функция вызывается и в фильтрах, где пока нет никакого oForm и тем более oForm.$tabContent вообще. Но это hinducoding.
						{
							oForm.$tabContent.scrollspy("refresh");
						}

						// Последние две строчки для фильтров.
						var $sidePanelScrollable = $("#"+sDomId).parents("div.sidePanelScrollable")
						if($sidePanelScrollable.length) $sidePanelScrollable.resize();

						QForm.processMultipleEditControls($form);
					}
				}
			});
		}, this), 96);
		/**/
	}
})();


QForm.processButtonPressServerSide = (function()
{
	// будем препятствовать множественному вызову одного и того же обновления (это сделано пока что в первую очередь для fieldset)
	// TODO надо доработать. Например, если мы вызываем обновление поля foo, а потом вызываем обновление полей foo и bar, то мы должны первое пропустить. Сейчас же будет выполнено два обновления. Но пока это не критично
	var oiTimers = {};
	return function($form, btnName, $btn)
	{
		clearTimeout(oiTimers[btnName]);

		var aDataToSend = this._processAjaxVars($form);
		var sFormName = $form.data("qform-name");

		var sWorkspace = (Q.WORKSPACE.length) ? "/"+Q.WORKSPACE : "";
		if(empty(sUrl)) sUrl = sWorkspace+"/q/"+sFormName+"/button/"+btnName+"/press";

		if($btn !== null) $btn.data("loading-text","Выполняю...").buttonStartLoading();
		oiTimers[btnName] = setTimeout($.proxy(function()
		{
			$.ajax(sUrl,
			{
				type: "POST",
				data: aDataToSend,
				dataType: "json",
				success: function(mResponse)
				{
					if($btn !== null) $btn.buttonStopLoading();

					if(mResponse.success)
					{

					}
					else
					{
						QForm.fnThrowStoreError(1);
					}
				},
				error: function()
				{
					QForm.fnThrowStoreError(2);
				}
			})
		}, this), 96);
		/**/
	}
})();

QForm._processAjaxVars = function($form, aFieldsToSend)
{

	var oForm = $form.data("qform-object");

	var sFormName = $form.data("qform-name");
	var aDataToSend = {};
	aDataToSend.internal = {};

	aDataToSend.internal = this.fnGetFieldsDataToSend($form, aFieldsToSend);

	var id = $form.data("qform-ids");
	//alert(id.length);
	if(!empty(id)) if(id.length == 1) id = id[0];
	if(id) aDataToSend.id = id;
	if(oForm) aDataToSend.qparent = oForm.sParentFileName;

	 return aDataToSend;
}

QForm.fnGetFieldsDataToSend = function($form, aFieldsToSend)
{

	var aFieldsDataToSend = {};

	var aFormData = $form.find(":input").serializeJSON({verifyFunction:function(input) // исключим поля фильтров
	{
		if($(input).closest("div.q-filter").length) return false;
		else return true;
	}});

	//console.dir(aFormData);


	if(empty(aFieldsToSend)) aFieldsDataToSend = aFormData;
	else
	{
		$.map(aFieldsToSend, function(sField)
		{
			/***
			if(sField.split('[]').length>2)
			{
				sField = sField.split('[]')[0];
				if(empty(aDataToSend.internal[sField])) aDataToSend.internal[sField] = [];
				aDataToSend.internal[sField][aDataToSend.internal[sField].length] =
			}
			***/
			aFieldsDataToSend[sField] = aFormData[sField];
		});
	}

	var sField;
	for(sField in aFieldsDataToSend)
	{
		//console.log(aDataToSend.internal[sField]);
		if(aFieldsDataToSend[sField] instanceof Array)
			aFieldsDataToSend[sField] = aFieldsDataToSend[sField].join(",");
	};

	//console.log("aFieldsDataToSend: %o", aFieldsDataToSend);

	return aFieldsDataToSend;

}

QForm.fnInitElement_list = function($el, oOptions)
{

	var $tab = $el.closest('.tab-pane');
	var $tabContent = $tab.closest(".tab-content");

	var $form  = $el.closest("form"); // у нас может и не быть таба.
	//console.log($tab.attr("id"));
	//console.dir($el.closest('.tabbable').children());

	var fn = function()
	{

		$.ajax(((Q.WORKSPACE!="")?"/"+Q.WORKSPACE:"")+"/q/"+oOptions.sFormName+"/list_embeded/"+oOptions.sElement
			  +"?QCACHE_GUID="+oOptions.form_guid,
		{
			// type: "POST",
			// data: aDataToSend,
			dataType: "html",
			success: function(sHtml)
			{
				var $elNew = $el.html(sHtml);

				// alert($form.is(".q-form-scrollable"));
				if($form.is(".q-form-scrollable"))
				{
					setTimeout(function(){ $tabContent.scrollspy("refresh"); },1000)
				}
			}
		});

	};

	// alert($form.is(".q-form-scrollable"));

	if($form.is(".q-form-scrollable"))
	{
		var fnCheckScroll = function()
		{
			// console.dir($tabContent);
			// console.log("tab =",$tab.attr("id"));
			// console.log("($tab.offset().top - $tabContent.offset().top) < ($tabContent.outerHeight() - 15)",($tab.offset().top - $tabContent.offset().top),"<",($tabContent.outerHeight() - 15),"→",($tab.offset().top - $tabContent.offset().top) < ($tabContent.outerHeight() - 15));
			// console.log("($tab.offset().top - $tabContent.offset().top) > -1 * $tab.outerHeight()",($tab.offset().top - $tabContent.offset().top),"<",-1 * $tab.outerHeight(),"→",($tab.offset().top - $tabContent.offset().top) > -1 * $tab.outerHeight());

			if(    ( ($tab.offset().top - $tabContent.offset().top) < ($tabContent.outerHeight() - 15) )
				&& ( ($tab.offset().top - $tabContent.offset().top) > -1 * $tab.outerHeight() )
			)
			{
				fn();
				$tabContent.off("scroll."+$tab.attr("id"));
			}
		}

		$tabContent.scrollEnd(fnCheckScroll, $tab.attr("id"), 100);
		fnCheckScroll();

	}
	else
	{
		if($tab.is(":visible")) fn();
		else
		{
			$el.closest('.tabbable').children().filter('.nav').find('a[data-toggle="tab"]')
						.filter('[href="#'+$tab.attr("id")+'"]')
						.one('shown.bs.tab', fn);
		}
	}
}

QForm.fnProcessFieldsetCount = function($el)
{
	var $elClone = $el; //.clone(true);
	$elClone.find(".QFieldsetMinusBtn").toggleClass("disabled",($el.find(".qfieldset-row").length <= 1));
	var i = 0;
	$elClone.find(".qfieldset-row").each(function()
	{
		var $row = $(this);
		var $rowNumber = $row.children("div.qfieldset-row-number");
		var n = (i+1).toString();
		if($rowNumber.text()!=n) $rowNumber.text(n);
		i++;
	});
	if($el.data("max-num") === undefined) $elClone.data("max-num", i);
	// $el.replaceWith($elClone);
}
// #TODO Устанавливать disabled не каждой конкретной кнопке, а через класс к самому филдсету
QForm.fnInitFieldset = function($el, oOptions)
{
	$el.data("pattern", oOptions.pattern);

	QForm.fnProcessFieldsetCount($el); // обрабатывает кнопки + / - и блокирует кнопку удаления, если строчек больше нет

	$el.on('click', '.qfieldset-button', function(e)
	{
		//console.time('Total');
		//console.dir(e);
		var $row = $(e.target).closest(".qfieldset-row");
		var bAdd = $(e.target).is(".QFieldsetPlusBtn");
		if(bAdd)
		{
			//console.time('Get Pattern');
			var oPattern = $el.data("pattern");
			//console.timeEnd('Get Pattern');
			var sHtml = oPattern.html;
			var sJS = oPattern.js;

			var sHtml = "";

			var iNum = $el.data("max-num") + 1;
			$el.data("max-num", iNum);

			var sAddClass = "";
			// Проверяем, если филдсеты сортируемые, то добавляем еще один класс
			if($(".q-sortable-list").length !== 0)
				sAddClass = "ui-sortable-handle";

			//console.time('Generate HTML');
			// ВАЖНО! К сожалению, при внесении правок здесь, необходимо ещё исправить qfieldset.class printThis #TODO: DRY!
			sHtml += "<div class=\"qfieldset-row row" +sAddClass+ "\">";
			sHtml += "<div class=\"qfieldset-row-number d-table-cell\"><span class=\"qfieldset-row-number-circle\">"+(iNum)+"</span></div>";
			sHtml += "<div class=\"qfieldset-rows-section d-table-cell col-md-10\">";
			sHtml += oPattern.html.split("%%i%%").join(iNum);
			sHtml += "</div>";
			sHtml += "<div class=\"qfieldset-buttons d-table-cell col-md-2\">";
			sHtml += "<div class=\"qfieldset-button QFieldsetPlusBtn btn btn-light\">+</div>";
			sHtml += "<div class=\"qfieldset-button QFieldsetMinusBtn btn btn-light\">−</div>";
			sHtml += "</div>";
			sHtml += "</div>";
			//sHtml += "<script type=\"text/javascript\">";
			//sHtml += oPattern.js.split("%%i%%").join(iNum);
			//sHtml += "</script>";
			//console.timeEnd('Generate HTML');

			//console.time('Dom manipulation');
			$row.after(sHtml);
			//console.timeEnd('Dom manipulation');

			//console.time('Processing JS');
			eval(oPattern.js.split("%%i%%").join(iNum));
			//console.timeEnd('Processing JS');
			QForm.fnProcessFieldsetCount($el);
		}
		else
		{
			if(! $row.find(".QFieldsetMinusBtn").is(".disabled")) $row.remove();
			QForm.fnProcessFieldsetCount($el);
		}
		//console.timeEnd('Total');
	});

	// Добавим возможность сортировки
	if($el.is('.q-sortable-list'))
	{

		$el.sortable({
			axis: 'y',
			// containment: 'parent',
			connectWith: '.q-sortable-list',
			start: function(e, ui)
			{
				$el.find(".ui-sortable-handle").addClass("dashed");
				$(ui.item).removeClass("dashed").addClass("grabbing");
				//$(e.target).addClass("grabbing");
			},
			stop: function(e, ui)
			{
				$(ui.item).removeClass("grabbing");
				$el.find(".ui-sortable-handle").removeClass("dashed");
				QForm.fnProcessFieldsetCount($el);
			}
		});

	};

	// Добавим функционал уникальных полей
	$el.off('change.feature-fieldset-unique-fields')
     .on( 'change.feature-fieldset-unique-fields'
        , 'select.q-fieldset-unique-field \
          , input.q-fieldset-unique-field[type=checkbox] \
          , input.q-fieldset-unique-field[type=radio]'

        , function(e)
	{
		var $target = $(e.target);
    var sOriginName = $target.data("name");

		// console.log("Event! %o %s %s", $target, sValue, e.target.tagName);

		switch(e.target.tagName.toLowerCase())
		{
			case "select":

				var sValue = $target.val();
				if(!sValue || (sValue == "0")) return;

				$el.find("select[data-name='"+sOriginName.encodeHTML()+"'] \
                  option[value='"+sValue.encodeHTML()+"']:selected")
				   .closest("select")
				   .not($target)
				   .val("").change();

				break;

			case "input":

				if($target.is(":checked"))
				{
					$el.find("input[data-name='"+sOriginName.encodeHTML()+"']:checked")
					   .not($target)
					   .attr("checked", "").removeAttr("checked").change();
				}

				break;
		}

	});

}

/*
 * @todo #TODO вынести в отдельный jQuery plugin
 */
QForm.fnInitField_commonstring = function($el, oOptions)
{
	$el.on('keydown', function(e)
	{

		if(e.ctrlKey || e.metaKey || e.altKey) return true;
		switch(e.keyCode)
		{
			case KEY.UP:
			case KEY.DOWN:
			case KEY.DEL:
			case KEY.TAB:
			case KEY.RETURN:
			case KEY.ESC:
			case KEY.PAGEUP:
			case KEY.PAGEDOWN:
			case KEY.BACKSPACE:
			case KEY.HOME:
			case KEY.END:

				return true;
		}

		var sVal = $el.val();
		var iSelectionStart = this.selectionStart;
		var iSelectionEnd = this.selectionEnd;

		//console.log("e.keyCode=",e.keyCode);
		// console.log("String.fromCharCode(e.keyCode)=",String.fromCharCode(e.keyCode));
		// console.log("iSelectionStart=",iSelectionStart);
		// console.log("iSelectionEnd=",iSelectionEnd);
		// console.dir(e);

		if(oOptions["trim"] && (trim(sVal, oOptions["trim-chars"]) == ''))
			if( oOptions["trim-chars"].toLowerCase()
					.indexOf(String.fromCharCode(e.keyCode).toLowerCase())
					!= -1
			)
				return false;

		if(oOptions["strict-space"] && e.keyCode == KEY.SPACE)
			if(iSelectionStart && sVal[iSelectionStart-1] == ' ')
				return false;

		var aPunkt = [".", ",", "!", "?", ";", ":"];
		var aPunktCodes = [KEY["."],KEY[","],KEY["!"],KEY["?"],KEY[";"]];

		if(oOptions["strict-punct"])
		{
			if(($.inArray(e.keyCode, aPunktCodes) != -1))
			{
				// если вводим пунктуацию и последний символ был пробелом, то обрежем его
				if(iSelectionStart && sVal[iSelectionStart-1] == ' ')
				{
					$el.val(sVal.substr(0,iSelectionStart-1)+sVal.substr(iSelectionStart));
					$el.selectFromTo(iSelectionStart-1, iSelectionEnd-1);
					sVal = $el.val(); iSelectionStart--; iSelectionEnd--;
				}
			}
			else
			{
				// если вводим что-то кроме пунктуации и последний был знаком препинания,
				// тогда добавим пробел
				if(iSelectionStart && e.keyCode != KEY.SPACE &&
					($.inArray(sVal[iSelectionStart-1],aPunkt)!= -1)
				)
				{
					$el.val(sVal.substr(0,iSelectionStart)+" "+sVal.substr(iSelectionStart));
					$el.selectFromTo(iSelectionStart+1, iSelectionEnd+1);
					sVal = $el.val(); iSelectionStart++; iSelectionEnd++;
				}
			}
		}

		return  true;
	});

	$el.on('keyup', function(e)
	{

		if(e.ctrlKey || e.metaKey || e.altKey) return true;
		switch(e.keyCode)
		{
			case KEY.UP:
			case KEY.DOWN:
			case KEY.DEL:
			case KEY.TAB:
			case KEY.RETURN:
			case KEY.ESC:
			case KEY.PAGEUP:
			case KEY.PAGEDOWN:
			case KEY.BACKSPACE:
			case KEY.HOME:
			case KEY.END:

				return true;
		}

		var sVal = $el.val();
		var iSelectionStart = this.selectionStart;
		var iSelectionEnd = this.selectionEnd;
		var aPunkt = [".", ",", "!", "?", ";", ":"];

		if(oOptions["ucfirst"] && !empty(sVal[0]) && (sVal[0].toUpperCase() != sVal[0]))
			$el.val(sVal[0].toUpperCase()+sVal.substr(1));

		// Если последний вставленный символ был пунктуационным, то вставим после него пробел
		if(oOptions["strict-punct"] && ($.inArray(sVal[iSelectionStart-1],aPunkt)!= -1))
		{
			$el.val(sVal.substr(0,iSelectionStart)+" "+sVal.substr(iSelectionStart));
			$el.selectFromTo(iSelectionStart+1, iSelectionEnd+1);
			sVal = $el.val(); iSelectionStart++; iSelectionEnd++;
		}
	});

	var parse = function()
	{
		var sVal = $el.val();

		if(oOptions["ucfirst"] && !empty(sVal[0]) && (sVal[0].toUpperCase() != sVal[0]))
			sVal = sVal[0].toUpperCase()+sVal.substr(1);

		if(oOptions["trim"]) sVal = trim(sVal, oOptions["trim-chars"]);

		if(oOptions["strict-punct"]) sVal = sVal.replace(/(?:\s+)?([\.\,\!\?\;\:])+/g,"$1 ");
		if(oOptions["strict-space"]) sVal = sVal.replace(/(\s)\s+/g,"$1");

		$el.val(sVal);
	}

	$el.on('change blur', parse);
}

QForm.fnInitField_textarea = function($el, oOptions)
{
	if(oOptions.noreturn)
	{
		$el.keydown(function(evt)
		{
		    if (evt.keyCode == 13)
		    {
		        evt.preventDefault();
		    }
		});
	}

	//alert($el.attr("x-webkit-speech"));
	if(0) //!empty($el.attr("x-webkit-speech")))
	{
		var sTextAreaId = $el.attr("id");
		var sSpeechId = 'speech_for_'+sTextAreaId;
		$el.after('<input x-webkit-speech class="speech_for_textarea" id="'+sSpeechId+'" tabindex="-1"/>');

		var speech = document.getElementById(sSpeechId);
		speech.onfocus = function(e){ document.getElementById(sSpeechId).value=''; };
		speech.onwebkitspeechchange = function(e) {
		    //console.log(e); // SpeechInputEvent
		    document.getElementById(sTextAreaId).value = speech.value;
		    $('#'+sTextAreaId).focus().putCursorAtEnd().keyup();
		};
		$el.css("padding-right", 20);
	}
}

QForm.fnInitField_checkboxgroup_postponed = function($el, oOptions)
{

	if(oOptions.extended === 1)
	{
		var aTimeoute = new Array(); // Массив для идентификаторов timeout
		var icountTimeouts = 0; // Количество тайм-аутов, который выполняются в данный момент
		var iCheckUncheck = 1; //
		var iShowHide = 1; //
		var $Container = $el.closest(".q-field");
		var sContainerID = $Container.attr("id");
		var sAllCheckboxes = '#'+sContainerID+' label input[type=checkbox]';
		var $LblCheckBoxesParent = $Container.find('.controls'); // Объект, содержащий все checkbox
		var sPrefix = $Container.children(".control-label").attr("for");
		var sInputSeacrh = sPrefix+'searchBox'; // Имя контейнера с поисковой строкой и кнопками
		$LblCheckBoxesParent.prepend('<div id="'+sInputSeacrh+'" class="container-search-checkbox">'); // Добавляем контейнер с поисковыми данными
		var $InputSeacrh = $('#'+sInputSeacrh); // Объект контейнера

		// --------------------------------------------------------------
		// Добавляем содержимое
		// --------------------------------------------------------------
		var $QCheckboxGroup = $('#'+sContainerID+' .controls .input-group .q-checkbox-group');

		var bCheckUnckeckAll = oOptions.bCheckUnckeckAll;
		var bShowHide = oOptions.bShowHide;
		var bShowUpdate = oOptions.bShowUpdate;
		var link = oOptions.link;
		var linkHelp = oOptions.linkHelp;
		link = link.trim();

		var sAppend = '';


		if(bCheckUnckeckAll==1) {
		 	sAppend = sAppend + '<button class="btn btn-small" name="btnCheckUnckeckAll" title="Отметить Все"><i class="icon-check" style="color: #333"></i></button>';
		}

		if(bShowHide==1) {
		 	sAppend = sAppend + '<button class="btn btn-small" name="btnShowHide" title="Показать Отмеченные"><i class="icon-show-lines" style="color: #333"></i></button>';
		}

		if(bShowUpdate==1) {
		 	sAppend = sAppend + '<button class="btn btn-small" name="btnShowUpdate" title="Обновить"><i class="icon-refresh" style="color: #333"></i></button>';
		}

		if(link!=="") {
		 	sAppend = sAppend + '<button class="btn btn-small" name="btnLinkTo" data-link="'+ link + '" title="' + linkHelp + '"><i class="icon-link" style="color: #333"></i></button>';
		}

		$InputSeacrh.append('<div class="pull-left"><input  type="text" class="span2 search-query search-text" id="inputIcon"  name="chSearch"  placeholder="Поиск по значениям…" /></div>');
		$InputSeacrh.append('<div class="btn-group">'+sAppend+'</div>');

		var $inputSearch 			 = $('#'+sInputSeacrh+' input[name=chSearch]');
		var $btnBtnCheckUnckeckAll 	 = $('#'+sInputSeacrh+' button[name=btnCheckUnckeckAll]');
		var $inputCheckbox 			 = $('#'+sContainerID+' input[type=checkbox]');
		var $btnBtnShowHide 		 = $('#'+sInputSeacrh+' button[name=btnShowHide]');
		var $btnBtnShowUpdate 		 = $('#'+sInputSeacrh+' button[name=btnShowUpdate]');
		var $btnBtnLinkTo 		     = $('#'+sInputSeacrh+' button[name=btnLinkTo]');
		var $InputGroup 		 	 = $('#'+sContainerID+' .input-group');

		if(oOptions.disabled) $btnBtnCheckUnckeckAll.addClass("disabled").attr("disabled", 1);

		$btnBtnCheckUnckeckAll.tooltip({delay: {show:500, hide:100}});
		$btnBtnShowHide.tooltip({delay: {show:500, hide:100}});
		$btnBtnShowUpdate.tooltip({delay: {show:500, hide:100}});
		$btnBtnLinkTo.tooltip({delay: {show:500, hide:100}});

		$btnBtnShowUpdate.click(function()
		{
			QForm.fnUpdateElement($el.closest("form"), oOptions.sElementName);
			return false;
		});
		$btnBtnLinkTo.click(function()
		{
			var link= $(this).data("link");
			window.open(link);
			return false;
		});
		// Добавляем стили
		$InputSeacrh.css('width', $QCheckboxGroup.outerWidth());
		$QCheckboxGroup.attr('class', $QCheckboxGroup.attr('class')+' checkbox-margin');


		$inputSearch.addClearButton();
		$QCheckboxGroup.prepend('<div class="nothing-found" style="display: none;"><span>Ничего не найдено</span></div>');

		// --------------------------------------------------------------
		// Определяем события
		// --------------------------------------------------------------

		// События ввода в поле поиска
		$inputSearch.bind('keyup change', function(e)
		{
  			var $this = $(this);
  			var sValue = $this.val(); // Значение в поле поиска
  			var $Label = $LblCheckBoxesParent.find('label');
  			showAll();
  			$Label.removeHighlight(); // убираем подсветку
  			if(sValue.length>0) // Если поле не пустое, то ищем схожие значения
  			{
		        var searchTerm = $this.val();
		        if ( searchTerm )
		        {
		            $Label.highlight( searchTerm, 'highlight' ); // подсветить значение
		          	$Label.hide();
  					$('#'+sContainerID+' label .highlight').parent().show();
		        }
  			}
  			else
  			{
  				$Label.show(); // Если поле пустое, то показываем все варианты
  			}
  			checkResult(false, 'Ничего не найдено');
		});

		// События кнопок {Отметить Все,Очистить Все} $btnBtnCheckUnckeckAll
		$btnBtnCheckUnckeckAll.bind('click', function()
		{
			if($btnBtnCheckUnckeckAll.is(":disabled")) return false;
			showAll();
			var $this = $(this);
  			iCheckUncheck = 1 - iCheckUncheck;
  			$this.html('<i class="'+(iCheckUncheck?'icon-check':'icon-unchecked')+'"></i>');
			$this.data('original-title',(iCheckUncheck?"Отметить Все":"Снять все отметки"));
			$this.attr('class', 'btn btn-small'+(iCheckUncheck?'':' active'));
			$this.tooltip({delay: {show:500, hide:100}});
			$('#'+sContainerID+' label:visible input[type=checkbox]').trigger('change');
			return checkboxAttr('#'+sContainerID+' label:visible input[type=checkbox]', {checked:(iCheckUncheck?false:true)});
		});

		$inputCheckbox.click(function()
		{
			var $this = $(this);
			if( iShowHide === 0 )
			{
				if(!$this.attr('checked'))
				{
					aTimeoute[$this.val()] = setTimeout( function(){checkboxOperation($this);}, 2000); // Добавляем тайм-аут
					icountTimeouts++;
				}
				else
				{
					clearTimeout(aTimeoute[$this.val()]); // Если успели вернуть галочку, то удаляем тайм-аут
					if(icountTimeouts>0) icountTimeouts--;
				}
			}
		});

		// События кнопки {"Показать Все", "Показать Отмеченные"}
		$btnBtnShowHide.bind('click', function()
		{
			var $this = $(this);
			iShowHide = 1 - iShowHide;
			var sLabels = '#'+sContainerID+' .checkbox';
			$this.html('<i class="'+(iShowHide?'icon-show-lines':'icon-list')+'"></i>');
			$this.data('original-title',(iShowHide?"Показать Отмеченные":"Показать Все"));
			$this.attr('class', 'btn btn-small'+(iShowHide?'':' active'));
			$this.tooltip({delay: {show:500, hide:100}});

			if(iShowHide){
				$(sLabels).show();
			}
			else
			{
				$(sLabels).hide();
				$(sLabels+' input:checked').parent().show();
			}

			checkResult(true, 'Ничего не выбрано');
			return false;
		});

		//checkResult(false, null);
		// --------------------------------------------------------------
		// Определяем функции
		// --------------------------------------------------------------

		// Определяем атрибуты
		function checkboxAttr(selector, attributes)
		{
			console.warn(selector);

			for(var i in attributes)
			{
				$(selector).attr(i, attributes[i]);
			}
  			return false;
		}

		// Проверяем пустой результат
		function checkResult(flag, text)
		{
			var sCheckbox = '#'+sContainerID+' input[type=checkbox]';
			var oNothingFound = $('#'+sContainerID+' .controls .nothing-found');
			flag = ($('#'+sContainerID+' label[class=checkbox]:visible').length < 1 && ( (!flag) ? true : (icountTimeouts<1 && !$(sCheckbox+':checked').val())));
			if(flag) oNothingFound.text(text);
			(flag) ? oNothingFound.show() : oNothingFound.hide();
			$InputGroup.children().css('padding', (flag)  ? '10px' : '0px 4px' );
		}

		// Скрываем поля в режиме "Показывать только отмеченные";
		function checkboxOperation(obj)
		{
			if(icountTimeouts>0) icountTimeouts--;
			obj.parent().hide();
			checkResult(true, 'Ничего не выбрано.');
		}

		function showAll(){
			if($('#'+sContainerID+' .btn-group .icon-list').length>0)
  			{
  				for(var i in aTimeoute)
				{
					clearTimeout(aTimeoute[i]); // Удалеяем все timeOut
					if(icountTimeouts>0) icountTimeouts--;
				}
				$btnBtnShowHide.trigger('click');
  			}
		}
	}
}


QForm.fnInitField_combobox_postponed = function($el, oOptions)
{
	$el.addClass("combobox");

	if($el.data("readonly")) var bReadonly = true;
	else var bReadonly = false;
	if($el.data("disabled")) var bDisabled = true;
	else var bDisabled = false;

	var oDataFields = this.fnGetFieldsDataToSend($el.closest("form"));
	//console.log("oDataFields: %o", oDataFields);


	if(! (bReadonly || bDisabled))
	{
		$el.autocomplete(oOptions.sAutocompleteURL,
		{
			extraParams: {field: oOptions.sField_safe, internal:oDataFields},
			method: "POST",
			autoFocus: false,
			delay: 300, // д.б. > 150
			minChars: 0,
			autoFill: false,
			dataType: "json",
			scrollHeight: 220,
			max: 150,
			width: $el.outerWidth(), // изначально у нас $el идет во всю ширину input-group. Кнопка, которая уменьшит его ширину, будет добавлена позже (ниже по коду).
			multiple: false,
			max: 0,
			formatItem:function(data, i, total)
			{
				//console.log(data.label+(data.additional?("<em>"+data.additional+"</em>"):""));
				return data.label+(data.additional?("<em>"+data.additional+"</em>"):"");
			},
			parse: function(data)
			{
				var parsed = [];
				var i;
				for(i in data)
				{
					parsed[i] = {};
					parsed[i].data = data[i];
					parsed[i].value = data[i]["label"];
					parsed[i].result = data[i]["label"];
				}
				//console.dir(parsed);
				return parsed;
			},
			onHide: function(input, select)
			{
				$(input).removeClass("open");
			},

			onItemSelect: function(value, $input, data)
			{

				$input.val(de_htmlspecialchars(value));

				return false;
			}
		}).prev('ul').detach().prependTo($el.parent());
	}

	$(' <a tabindex="-1" class="combobox-btn dropdown-toggle" href="#"'+(bReadonly||bDisabled?' disabled="disabled"':'')+'>\
			<span class="caret"></span>\
		</a>').insertAfter($el);
	var $btn = $el.next("a.combobox-btn");

	if(! (bReadonly || bDisabled))
	{
		$btn.mousedown(function()
		{
			if($el.is(":focus")) return false; // чтобы фокус не уходил
		})
		.click(function()
		{
			//$(document).click();

			if(!$el.is(".open"))
			{
				console.warn('Opening');
				if(!$el.is(":focus")) $el.focus();

				$el.addClass("open");
				//console.log("combobox-btn has been clicked");
				//$el.blur();
				$el.acomplete();
			}
			else
			{
				$el.removeClass("open").hideresults();
			}
			return false;
		});
	}

	//$el.width($el.width()-25); // уменьшим ширину на ширину кнопки @todo: высчитывать ширину кнопки автоматически.
}

/**
 * @TODO прокомментировать весь код функции.
 */
QForm.fnInitField_autocomplete_postponed = function($el, oOptions)
{

	var bDisabled = $el.is(":disabled") || $el.is("[readonly]");

	//if(empty(bIsCombobox)) bIsCombobox = 0;
	if(oOptions.bIsRestricted)
	{

		$el.addClass("qfield-autocomplete-restricted");

		var $inputGroup = $el.parent(".input-group");

		var $selContainer =

				$inputGroup
				   .clone()
				   .hide();

		$selContainer.find('input').replaceWith("<button class=\"form-ac-selected"+(bDisabled?" disabled\" tabIndex=\"-1":"")+"\">\
				            <span class=\"form-ac-selected-text\"></span>\
				            <span class=\"autocompleteAdditional\"></span>\
				          </button>");

		$selContainer.insertAfter($inputGroup);

		// Посмотрим, может в поле уже есть какое-то значение:
		if(!empty($el.val()))
		{
			$selContainer.find(".form-ac-selected-text").html($el.data("focused-label"));
			$selContainer.find(".autocompleteAdditional").html($el.data("focused-additional"));
			$selContainer.show();
			$inputGroup.hide();
		}

		$selContainer
			.click(function()
			{
				var $this = $(this);
				if($this.children(".form-ac-selected").is(".disabled"))
				{
					$this.children(".form-ac-selected").blur();
					return false;
				}

				var sTerm = $el.data("term");
				if(typeof(sTxt) == 'undefined') sTerm = "";
				var sTxt = $this.find("span.form-ac-selected-text").text();
				if(typeof(sTxt) == 'undefined') sTxt = "";
				//console.log("new val: "+sTxt);
				$this.hide();
				//$this.next(".autocompleteAdditional").hide();

				$inputGroup.show();
				$el
					.val(sTerm)
					.focus()
					//.acomplete()
					.val(sTxt)
					.selectFromTo(sTerm.length, sTxt.length);

				return false; // чтобы перпятствовать отправке формы
			} );

		var fnSelectItem = function (sId, sLabel, sAdditional)
		{
			if($el.parent().is(":hidden")) return false;

			//console.log("Selected item: "+sId);

			$el.val(sId).change();
			$inputGroup.hide(); // change например для того, чтобы оповестить фильтры.
			$selContainer.show();

			$selContainer.find("span.form-ac-selected-text").html(sLabel);
			$selContainer.find("span.autocompleteAdditional").html(sAdditional);
				/***
				.next(".autocompleteAdditional")
					.show()
					.text(sAdditional);
				/***/
			//alert($el.val());
			//alert('selected');
		};

	};

	var oDataFields = this.fnGetFieldsDataToSend($el.closest("form"));
	//console.log("oDataFields: %o", oDataFields);

	$el.autocomplete(oOptions.sAutocompleteURL,
	{
		extraParams: {field: oOptions.sField_safe, internal:oDataFields},
		autoFocus: true,
		delay: 300,
		minChars: 1,
		method: "POST",
		//autoFill: true, // Самостоятельно будем заполнять
		/*mustMatch: oOptions.bIsRestricted,*/
		dataType: "json",
		scroll: true,
		max: 100,
		scrollHeight: 220,
		max: 150,
		width: 0,
		pullright: oOptions.bPullRight,
		multiple: oOptions.bIsMultiple,
		multipleSeparator: oOptions.sSeparator,
		bNoWrap: oOptions.bNoWrap,
		onItemSelect:
		(
			oOptions.bIsRestricted ?
			function(value, $input, data)
			{
				var label = data.label;
				var additional = data.additional;
				var id = data.id;

				$input.data("focused-id", id);
				$input.data("focused-label", label);
				$input.data("focused-additional", additional);

				fnSelectItem(id, label, additional);

				$selContainer.find("button.form-ac-selected").focus();

				return false;
			}
			:
			function(value, $input, data)
			{

				$input.val(de_htmlspecialchars(value));

				return false;
			}
		),
		formatItem:function(data, i, total)
		{
			//console.log("data:"+data+"; i:"+i+"; total:"+total);
			//return false;
			return data.label+(data.additional?("<em>"+data.additional+"</em>"):"");
		},
		parse: function(data)
		{
			var parsed = [];
			var i;
			for(i in data)
			{
				parsed[i] = {};
				parsed[i].data = data[i];
				parsed[i].value = data[i]["label"];
				parsed[i].result = (oOptions.bIsRestricted) ? data[i]["id"] : data[i]["label"];
			}
			return parsed;
		},
		onFocus: function(value, $input, data)
		{
			var label = data.label;
			var additional = data.additional;
			var id = data.id;

			var term = $input.data("term");

			var label_stripped = de_htmlspecialchars(label).replace(/(<([^>]+)>)/ig,"");

			//console.log('ttt');
			if(!oOptions.bIsMultiple)
			{
				$input
					.val(de_htmlspecialchars(label_stripped))
					.selectFromTo(term.length, label_stripped.length);
			}

			//console.log("on focus data:"+data.label);
		}
	});

	if(oOptions.bIsMultiple)
	{
		$el.bind('blur focus', function(e)
		{
			var $this = $(this);
			var sCurrVal = $this.val();
			if(!empty(sCurrVal))
			{
				var aCurrVal = sCurrVal.split(oOptions.sSeparator);
				if(empty(aCurrVal[aCurrVal.length-1]))
				{
					aCurrVal.splice(aCurrVal.length-1, 1);
				}
				sCurrVal = aCurrVal.join(oOptions.sSeparator);
				$this.val(sCurrVal+(e.type=='focus'?oOptions.sSeparator:''));
			}
		});
	}


	if(oOptions.bIsRestricted)
	{
		$el.bind('blur keyup', function(e)  // по нажатию клавиши или при расфокусировки
		{
			// Должно срабатывать только если нажали ENTER. Проверим на это дело.
			if(e.type === 'keyup' && e.keyCode !== 10 && e.keyCode !== 13) return;
			var $this = $(this);
			if($this.is(":visible"))
			{
				var label_stripped = de_htmlspecialchars($this.data("focused-label")).replace(/(<([^>]+)>)/ig,"");
				if($this.val() && ($this.val() == label_stripped))
				{
					//alert($this.attr("focusedtext")+" - "+$this.attr("focuseditem"));
					fnSelectItem($this.data("focused-id"), $this.data("focused-label"), $this.data("focused-additional"));
				}
				else
				{
					$this.val("");
					$this.data("focused-id", "");
					$this.data("focused-label", "");
					$this.data("focused-additional", "");
					$this.data("lastinput", "");
				}
			}
		});
	};

	if(!bDisabled)
	{
		$el.mousedown(function()
		{
			if($el.is(":focus")) return false; // чтобы фокус не уходил
		})
		.click(function()
		{
			if(!empty($el.val())) return;
			//$(document).click();

			if(!$el.is(".open"))
			{
				console.warn('Opening');
				if(!$el.is(":focus")) $el.focus();

				$el.addClass("open");
				//console.log("combobox-btn has been clicked");
				//$el.blur();
				$el.acomplete();
			}
			else
			{
				$el.removeClass("open").hideresults();
			}
			return false;
		});
	}

	return false;
};

QForm.fnInitField_email = function($el, oOptions)
{

};

QForm.fnInitField_password = function($el, oOptions)
{
	var bRepeat = oOptions.bRepeat;

	if(bRepeat)
	{
		var sInputId = $el.attr("id");
		var sCheckerId = sInputId+"Checker";
		$el.after("<div class='check-pass-block'><label class='checkbox' for='"+sCheckerId+"'><input type='checkbox' id='"+sCheckerId+"'/> Показать пароль</label></div>");
		$("#"+sCheckerId).change(function()
		{
			var domEl = document.getElementById(sInputId);
			if($(this).is(":checked"))
			{
				domEl.type="text";
			}
			else
			{
				domEl.type="password";
			}
		});
	}
};

QForm.fnInitField_map_postponed = function($el,oOptions)
{
// alert("!");
	$el.qGis(oOptions);

}

QForm.fnInitField_date = function($el, oOptions)
{
	//$el.datepicker();
	$el.parent(".input-group").css({"min-width":$el.closest(".q-filter").length?69:71 + 10 + 27}).addClass("fieldDate");
	if($el.closest(".q-filter").length) $el.width(69);
	else $el.width(71);

	var bDisabled = ($el.attr("readonly"))||($el.attr("disabled"));

	$el.addClass("datepicker-input");
	$el.after('<span class="btn calendar-btn input-group-addon"><i class="icon-calendar"></i></span>'); // добавим кнопку с календариком.
	var sVal = $el.val();
	//console.log(oCurrDate.asString());
	$el.parent().addClass("date")
		.data("date", sVal?sVal:false)
		.data("date-format", "dd.mm.yyyy")
		.data("date-weekstart", 1);

	var $calendarBtn = $el.next('span.btn');

	if(bDisabled)
	{
		$calendarBtn.attr("disabled", 1);
		// больше ничего и не требуетсяю
	}
	else
	{
		/**/

		var sdtStart = oOptions.startDate;
		var sdtEnd = oOptions.endDate;
		var sdomidStartField = oOptions.startDateField;
		var sdomidEndField = oOptions.endDateField;

		var endDateShift = oOptions.endDateShift;
		var startDateShift = oOptions.startDateShift;

		var fnAddShift = function(sDate, interval)
		{	if (!interval){
				return sDate;
			}
			if (sDate==''){
				return sDate;
			}
			var dt = Date.fromString(sDate);
			if (sDate.substr(6,4)!=dt.getFullYear()){
				return sDate;
			}
			dt.addDays(interval);
			return dt.asString();
		}

		if(sdomidStartField)
		{
			sdtStart = fnAddShift($("#"+sdomidStartField).val().substr(0,10), startDateShift);
			//alert("#"+sdomidStartField);
			$("#"+sdomidStartField).bind("change blur", function()
			{
				var sdtStartNew = fnAddShift($(this).val().substr(0,10), startDateShift);
				if(empty(sdtStartNew)) sdtStartNew = false;
				$el.parent().datepicker().datepicker('setStartDate', sdtStartNew);
				$el.data("startDate", sdtStartNew).change();
			});
		}
		if(sdomidEndField)
		{
			sdtEnd   = fnAddShift($("#"+sdomidEndField).val().substr(0,10), endDateShift);

			$("#"+sdomidEndField).bind("change blur", function()
			{
				var sdtEndNew = fnAddShift($(this).val().substr(0,10), endDateShift);
				if(empty(sdtEndNew)) sdtEndNew = false;
				$el.parent().datepicker().datepicker('setEndDate', sdtEndNew);
				$el.data("endDate", sdtEndNew).change();
			});
		}

		$el.data("startDate", sdtStart);
		$el.data("endDate", sdtEnd);

		$el.parent().datepicker(
		{
			"pullright":1,
			"startDate":sdtStart,
			"endDate":sdtEnd,
			"todayBtn":true,
			"todayHighlight":true,
			"language":"ru",
			"keyboardNavigation":true,
			"autoclose":true
		});

		$el.bind("change blur", function()
		{
			if($el.val().length < 10) $el.val('');
		});

		// Установим валидатор:
		$el.bind('blur change', function()
		{
			var sVal = $el.val();
			//console.log("sVal",sVal);
			if(sVal=='')
			{
				//if($el.data("startDate"))
				//	var sVal_etalon = $el.data("startDate");
				//else
					var sVal_etalon = "";
			}
			else
			{
				var dtVal_etalon = Date.fromString(sVal);

				if(!dtVal_etalon) return true;

				if(dtVal_etalon)
				{
					if($el.data("startDate"))
					{
						var dtStart = Date.fromString($el.data("startDate"));
						if(dtVal_etalon < dtStart) dtVal_etalon = dtStart;
					}
					if($el.data("endDate"))
					{
						var dtEnd= Date.fromString($el.data("endDate"));
						if(dtVal_etalon > dtEnd) dtVal_etalon = dtEnd;
					}
					var sVal_etalon = dtVal_etalon.asString();
				}
				else
				{
					if($el.data("startDate"))
						var sVal_etalon = $el.data("startDate");
					else
						var sVal_etalon = "";
				}

			}

			if(sVal_etalon==sVal) { return true; }
			else
			{
				$el.val(sVal_etalon).change();
				//console.dir($el);
			}

			$el.parent().datepicker("update");

		}).blur(); // И сразу же вызовем!!

	}
		//$el.attr("readonly", 1);
	/**/
};


QForm.fnInitField_datetime_postponed = function($el, oOptions)
{
	//$el.datepicker();
	// Временное решение! #TODO заменить на нормальный timepicker

	var bDisabled = ($el.attr("readonly"))||($el.attr("disabled"));

	$el.hide();
	var sVal = $el.val();
	var aVal = sVal.split(" ");

	var bRequired = $el.attr("required");

	var sNameEl = $el.attr("name");
	var domidEl = $el.attr("id");

	// раньше было так...
	// var sNameDt = sNameEl+"Date";
	// но конструкция неправильно работала с fieldset, т.к. Date надо добавлять не в конец, а перед скобкой [
	var sNameDt = sNameEl.split('[').map(function(s, i){ return s + ((i==0)?'Date':'') }).join('[');
	var domidDt = domidEl+"Date"; // ... А для DomId нам всё-равно

	//var sWidthDt = "75px"; // задается в fnInitField_date
	var sMaskDt = "99.99.9999";
	var sPlaceholderDt = "дд.мм.гггг";
	var sClassDt = "qfield-date form-control";

	// var sNameTm = sNameEl+"Time"; // см. аналогичное место для sNameDt
	var sNameTm = sNameEl.split('[').map(function(s, i){ return s + ((i==0)?'Time':'') }).join('[');
	var domidTm = domidEl+"Time";

	var sWidthTm = "60px";
	var sMaskTm = "99:99";
	var sPlaceholderTm = "чч:мм";
	var sClassTm = "form-control qfield-datetime-tm";

	var startTime = oOptions.startTime;
	var endTime = oOptions.endTime;

	var $inputGroup = $el.parent(".input-group").hide();
	var $container = $inputGroup.clone().css({"display":"flex"}).addClass("fieldDateTime");

	var $dtElement = $("<input/>")
			.attr("name", sNameDt)
			.attr("id", domidDt)
			.attr("placeholder", bDisabled?'':sPlaceholderDt)
			.attr("class", sClassDt)
			//.css("width",sWidthDt)  // задается в fnInitField_date
			.val(aVal[0]);
	if(bDisabled) $dtElement.attr("disabled",1);
	if(bRequired) $dtElement.attr("required", true);
	$container.find("input").replaceWith($dtElement);

	$dtElement.mask(sMaskDt, { clearIfNotMatch: true });
	//inputPlaceholder("#"+domidDt, "#ccc");

	var $tmElement = $("<input/>")
			.attr("name", sNameTm)
			.attr("id", domidTm)
			.attr("placeholder", bDisabled?'':sPlaceholderTm)
			.attr("class", sClassTm)
			.attr("type", "time")
			//.attr("required", bRequired)
			.css("width",sWidthTm)
			.val(aVal[1]);
	if(bDisabled) $tmElement.attr("disabled",1);
	if(bRequired) $tmElement.attr("required", true);
	//if(bRequired) $tmElement.attr("required", true); // на самом деле, хрен с ним. Если не указали время, значит 00:00
	//console.dir($container.find("#"+domidDt));
	$tmElement.mask(sMaskTm, { clearIfNotMatch: true });
	$tmElement.insertAfter($container.find("#"+domidDt));

	//inputPlaceholder("#"+domidTm, "#ccc");

	var updateDateTimeField = function()
	{
		var sDt = $dtElement.val();
		var sTm = $tmElement.val();


		if(!$tmElement.is(":focus"))
		{
			if(sTm < startTime)
			{
				sTm = startTime;
			}
			if(sTm > endTime)
			{
				sTm = endTime;
			}
			if(typeof sTm == 'string')
			{
				sTm = sTm.substr(0, 5);
				$tmElement.val(sTm);
			}
		}

		if(empty(sTm) && !empty(sDt)) sTm = "00:00";
		if(!empty(sTm) && empty(sDt)) sDt = "00.00.0000";

		//alert(sTm);

		if(!empty(sTm) && !empty(sDt)) sVal = sDt+" "+sTm;
		else sVal = "";

		$el.val(sVal).change();
	}

	$dtElement.bind('blur keyup change',updateDateTimeField); // keyup на всякий случай =)
	$tmElement.bind('blur keyup change',updateDateTimeField);

	$container.insertAfter($inputGroup);
	QForm.fnInitField_date($dtElement, oOptions);

};

QForm.fnInitField_time = function($el, oOptions)
{
	//$el.timepicker({showOn: "button", buttonImage: "/img/calendar.gif", clickInput:true});
};

QForm.fnInitField_rtf_postponed = function($el, oOptions)
{

	QForm.fnInitField_rtf_initRedactor($el, oOptions);

};

QForm.fnInitField_rtf_initRedactor = function($el, oOptions)
{
	$el.redactor(
	{
		lang: 'ru',
		cleanup: true,
		replaceDivs: false,
		mobile: true,
		minHeight: 240,
		maxHeight: 240,
		autoresize: false,
		plugins: ['fullscreen'],
		imageUpload: oOptions.sImageUploadUrl,
		imageUploadParam: 'img2upload',
		changeCallback: function()
		{
			$el.change();
		},
		codeKeydownCallback: function(e)
		{
			$el.change();
		},
		focus: true // ситуацию, когда у нас 2 rtf поля на одной вкладке мы отбросим как малореальную.
		/***
		toolbar: 'user',
		path: '/js/redactor/',
		pathCss: '/js/redactor/', css: ['rtf_editor_inner.css'],
		remove_classes:true,
		init_clear: true,
		remove_styles: true,
		convert_links: true // Установить false, если будут глюки с ссылками.
		/****/
	});

	$el.bind('destroyed', function() // remove when input removed (for example, when form closed)
	{
		$el.redactor('core.destroy');
	});
}

QForm.fnInitField_dropdown_postponed = function($el, oOptions)
{

	if ($el.data('convert') != 'no')
	{

		var elem_width = $el.width();
		//alert($el.width());
		//alert($el.width());

		var sElDomId = $el.attr("id");
		var sUlDomId = sElDomId+"_bootstrap_dd_ul";

		var dd_width = elem_width+8; // min-width для выпадающего списка
		///var t_width = elem_width+10; // ширина кнопки
		///var s_width = elem_width - 26; // ширина для строки поиска.

		if(dd_width < 170) dd_width = 170;

		//alert($el.width());

		var sCss = $el.attr("style");
		var sClass = $el.attr("class");

		var sEmptyMsg = "<em>Пустое значение</em>";
		var sCurrent = $el.find("option:selected").data("title");
		if(sCurrent == "") sCurrent = sEmptyMsg;

		if($el.attr("readonly")) var bReadonly = $el.attr("readonly");
		else var bReadonly = false;
		if($el.attr("disabled")) var bDisabled = $el.attr("disabled");
		else var bDisabled = false;
		if($el.attr("required") !== undefined) var bRequired = $el.attr("required");
		else var bRequired = 0;

		// Это очень важно. Т.к. в последствии подложка с вариантами выпадающего списка будет перемещена в body,
		// то она не будет удалена при удалении модального окна или замене содержимого fieldWrapper.
		// Поэтому у нас будет скапливаться мусор. Очищать мусор — сложно. Проще при инициализации заранее удалять
		// элементы <ul> с тем айдишником, который будет у нас.
		$("#"+sUlDomId).remove();


		var bExternalSelect = !empty($el.data("external-select"));

    	var $fineDD = $('<div tabindex="0" class="q-dropdown btn dropdown-toggle'+(bRequired?' required':'')+(oOptions.bIsExtended?' dropdown-extended':'')+'" data-tog___le="dropdown"'+(bReadonly||bDisabled?' disabled="disabled"':'')+'>\
    	                     <label class="choice-label">'+sCurrent+'</label>\
    	                     <span class="caret"></span>\
    	                 </div>'
						+ (bExternalSelect ? '<div class="btn qform-button-for-external-select"'+(bReadonly||bDisabled?' disabled="disabled"':'')+'>•••</div>' : '')
					);

    	if(bExternalSelect && !bReadonly && !bDisabled)
    	{
    		var $extBtn = $fineDD.filter(".qform-button-for-external-select");
    		$extBtn.click(function(e)
    		{
    			QForm.openExternalSelectDialog($el.attr("id"), $el.data("external-select-url"), $el.data("external-select-title"));
    			e.stopPropagation();
    			e.preventDefault();
    		});
    	}

		if(!empty(sClass)) $fineDD.addClass(sClass);
    	$fineDD.data("selected-label", sCurrent);
    	$fineDD.data("selected-value", $el.val());


    	var $fineDD_btn = $fineDD.filter(".q-dropdown");
    	var $fineDD_label = $fineDD_btn.find('label');

    	var $fineDD_ul = $( ! (bReadonly||bDisabled) ?
    	                 		'<div id="'+sUlDomId+'" class="qform-dropdown-menu dropdown-menu'+(oOptions.bPullRight?" pull-right":"")+(oOptions.bNoWrap?"":" wrappable")+'" style="overflow-y:auto"></div>'
    	              			:'' );

		var sCssWidth = $el.data("width");
		var iElWidth = $el.width();
		//console.log(sCssWidth);
		if(!empty(sCssWidth))
		{
			$fineDD_btn.css("width", sCssWidth); // Чтобы правильно работало с процентами закоментим и присвоим 100%
			//$fineDD_btn.css("width", "100%");
			//$fineDD.css("min-width", sCssWidth);
			$fineDD.css("width", sCssWidth);
		}
		else
		{
			//$fineDD_btn.width(iElWidth);
			//$fineDD.css("min-width", iElWidth);
		}
		$fineDD_ul.css("min-width", dd_width);

		$fineDD_btn.on(($.browser.opera ? "keypress" : "keydown"), function(e)
		{
			if( (e.keyCode == KEY.SPACE || e.keyCode == KEY.RETURN  || e.keyCode == 0) && $(e.target).is(".q-dropdown"))
			{
				$fineDD_btn.click();
				e.stopPropagation();
				e.preventDefault();
			}
		});

		if(! (bReadonly||bDisabled) )
		{

	    	// Теперь перенесем пункты из <select> в наш <ul>
			$el.find('option').each(function(o,q)
			{
				var sTxt = $(q).data("title");
				//console.log(sTxt);
				var $li = $('<a class="dropdown-item" href="javascript:;">' + (empty(sTxt)?sEmptyMsg:sTxt) + '</a>');
				$li.data("value", $(q).attr('value'));
				$li.data("label", sTxt);
				$li.toggleClass("active", !!$(q).attr('selected'));

				$li.appendTo($fineDD_ul);

				///if ($(q).attr('selected')) $fineDD.find('ul.dropdown-menu li:eq(' + o + ')').a;//.click();
			});
			if(oOptions.bIsExtended)
			{
				$fineDD_ul.append('<a class="dropdown-item nothing-found hidden-by-search"><span>Ничего не найдено</span></a>');
				// var $liNothingFound = $fineDD_ul.find("a.nothing-found");
			}
			var $fineDD_li = $fineDD_ul.find("a:not(.nothing-found)");

			$fineDD_ul.on('mousedown', 'a', function(event)
			{
			    event.preventDefault(); // это чтобы фокус $fineDD не терялся, иначе
			                            // будет вызвано событие $fineDD.blur, которое
			                            // закроет dropdown и click не выполнится (т.к. blur
			                            // срабатывает раньше, чем click)
			})
			.on('click', 'a', function(e)
			{
				var $this = $(e.currentTarget);
				//if($this.is(".searchElement")) return; // Проверим не строка ли это с формой поиска

				QForm.fnInitField_dropdown_selectItem($this, $fineDD, $fineDD_li, $fineDD_btn, $fineDD_label, $el, sEmptyMsg);

				$fineDD.absdropdown('hide');
				$fineDD.focus();

			});

			//if($el.css("width")!=="100%")

			// Если у нас дропдаун типа «extended», тогда рисуем строку поиска
	    	if(oOptions.bIsExtended)
	    	{
				$fineDD_btn.prepend('<label class="search-label"><input type="text" autocomplete="off" class="search-query0" style="width:100%" placeholder="Поиск…" ></label>');
				var $fineDD_inputSearch = $fineDD_btn.find("input.search-query0");
				$fineDD_inputSearch.addClearButton();

				$fineDD_inputSearch.click(function(e)
				{
					e.stopPropagation();
					e.preventDefault();
					return false;
				});

				var aSpecialChars = new Array( '\\', '.', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '[', ']', '{', '}', '/', '"', "'" );


				$fineDD_inputSearch
				.keyup(function()
				{
					var $this = $(this);
					var sSearch = $this.val();
					for(var i in aSpecialChars)
					{
						var sVal = aSpecialChars[i];
						sSearch = sSearch.split(sVal).join('\\'+sVal);
					}
					//console.log(sSearch);
					var $fineDD_ul_new = $fineDD_ul.clone(true, true);
					var $fineDD_li_new = $fineDD_ul_new.find("a:not(.nothing-found)");

					var $liNothingFound = $fineDD_ul_new.find("a.nothing-found");

					if(!empty(sSearch))
					{
						var $that = $this;
						var reSearch = new RegExp("("+sSearch+")","gi");
						var iFound = 0;

						$fineDD_li_new.each(function()
						{
							var $this = $(this);
							if($this.is(".searchElement")) return;
							var sTxt = $this.text(); // именно text, не html !!

							var aResult = sTxt.match(reSearch);
							if(aResult !== null)
							{
								$this.find("a").html(sTxt.replace(reSearch,"<b class='highlighted'>$1</b>"));
								$this.toggleClass("hidden-by-search", false);
								iFound++;
							}
							else $this.toggleClass("hidden-by-search", true);

						});
					}
					else
					{
						var iFound = 0;
						$fineDD_li_new.each(function()
						{
							var $this = $(this);
							var sTxt = $this.data("label");
							$this.toggleClass("hidden-by-search", false).find("a").html(sTxt);
							iFound++;
						});
					}

					$liNothingFound.toggleClass("hidden-by-search", !!iFound);

					$fineDD_ul.replaceWith($fineDD_ul_new);
					$fineDD_ul = $fineDD_ul_new;
					$fineDD_ul_new = null;
					$fineDD_li = $fineDD_ul.find("a:not(.nothing-found)");
					$fineDD_li_new = null;

				});

				$fineDD_btn.on('mousedown', function(event)
				{
					if($fineDD_btn.is(".dropdown-open")) // сложно сказать почему, но без этого условия не работает
					{
						event.preventDefault(); // это чтобы фокус $fineDD_inputSearch не терялся, иначе
						                        // будет вызвано событие $fineDD_inputSearch.blur, которое
						                        // закроет dropdown и click не выполнится (т.к. blur
						                        // срабатывает раньше, чем click)
					}
				});

				// Хак, решающий проблему с неработающим скроллом в IE (в ИЕ при нажатии на скролл идёт блур на dropdown. Должен был помочь event.preventDefault, но почему-то не помог)
				if($.browser.msie)
				{
					$fineDD_ul.on('mousedown', function(event)
					{
						$fineDD_inputSearch.bMouseIsDown = true;
						event.preventDefault();
						return false;

					});

					$fineDD_ul.on('mouseup', function(event)
					{
						$fineDD_inputSearch.bMouseIsDown = false;
					  	$fineDD_inputSearch.focus();
					});
				}

				$fineDD_inputSearch.blur(function(e)
				{
					// console.log($fineDD_inputSearch.bMouseIsDown);
					if(!$.browser.msie || !$fineDD_inputSearch.bMouseIsDown)
					{
						// console.log("hiding..");
						$fineDD.absdropdown("hide");
					}
				});

				$fineDD_inputSearch.bind('blur keyup change', function(e)
				{
					//console.log("atata");
					e.stopImmediatePropagation();
					e.preventDefault();
					e.stopPropagation();
				});

				$fineDD_ul.on("hidden.dropdown", function()
				{
					//console.log("hidden.dropdown catched");
					$fineDD_inputSearch.val("");
					$fineDD_inputSearch.keyup();
				});

			}
			else
			{
				// Хак, решающий проблему с неработающим скроллом в IE (в ИЕ при нажатии на скролл идёт блур на dropdown. Должен был помочь event.preventDefault, но почему-то не помог)
				if($.browser.msie)
				{
					$fineDD_ul.on('mousedown', function(event)
					{
						$fineDD.bMouseIsDown = true;
						event.preventDefault();
						return false;
					});

					$fineDD_ul.on('mouseup', function(event)
					{
						$fineDD.bMouseIsDown = false;
					  	$fineDD.focus();
					});
				}

				$fineDD.blur(function(e)
				{
					if(!$.browser.msie || !$fineDD.bMouseIsDown)
						$fineDD.absdropdown("hide");
				});
			}

			var $absolute = $el.closest('div.absolute');
			if(!$absolute.length) $absolute = $('body');
			$fineDD_ul.appendTo($absolute);

			$fineDD_btn.absdropdown("attach", "#"+sUlDomId);

			// Подключим функционал стрелочек

			var $liKbdActive = $fineDD_li.filter(".keyboard-active");
			var $liActive = $fineDD_li.filter(".active");

			if(!$liKbdActive.length)
			{
				if($liActive.length)
				{
					$liKbdActive = $liActive.addClass("keyboard-active");
				}
				else
				{
					$liKbdActive = $fineDD_li.eq(0);
				}
			}

			$fineDD_ul.on('hover', 'a', function(e)
			{
				$liKbdActive.removeClass('keyboard-active');
				$liKbdActive = $(e.currentTarget).addClass('keyboard-active');
			});

			$fineDD.on(($.browser.opera ? "keypress" : "keydown"), function(event)
			{

				if(!$fineDD.is(".dropdown-open")) return true;

				var $liSwitchTo;
				var bMoveForPage = false;
				var iItemsOnPage;
				switch(event.keyCode) {

					case KEY.PAGEUP:
						bMoveForPage = true;
					case KEY.UP:
						event.preventDefault();

						if(!bMoveForPage)
						{
							$liSwitchTo = $liKbdActive.prevAll("a:visible:first");
						}
						else
						{
							var $aLiPrev = $liKbdActive.prevAll("a:visible");

							var iDdHeight= $fineDD_ul.outerHeight();
							var iHeight = 0;
							$aLiPrev.each(function()
							{
								$liSwitchTo = $(this);

								iHeight += $(this).outerHeight();
								if(iHeight >= iDdHeight) return false;
							});
						}

						if(typeof($liSwitchTo)!== "undefined")
						if( $liSwitchTo.length )
						{
							$liKbdActive.removeClass("keyboard-active");
							$liSwitchTo.addClass("keyboard-active");
							$liKbdActive = $liSwitchTo;
							if(bMoveForPage)
							{
								$fineDD_ul.scrollTop($fineDD_ul.scrollTop()+$liKbdActive.position().top);
							}
							else if(!checkInView($liKbdActive, $fineDD_ul, false))
							{
								$fineDD_ul.scrollTop($fineDD_ul.scrollTop()+$liKbdActive.position().top);
							}
						}

						break;


					case KEY.PAGEDOWN:
						bMoveForPage = true;
					case KEY.DOWN:
						event.preventDefault();

						if(!bMoveForPage)
						{
							$liSwitchTo = $liKbdActive.nextAll("a:visible:first");
						}
						else
						{
							var $aLiNext = $liKbdActive.nextAll("a:visible");

							var iDdHeight= $fineDD_ul.outerHeight();
							var iHeight = 0;
							$aLiNext.each(function()
							{
								$liSwitchTo = $(this);
								iHeight += $(this).outerHeight();
								if(iHeight >= iDdHeight) return false;
							});
						}

						if(typeof($liSwitchTo)!== "undefined")
						if($liSwitchTo.length)
						{
							$liKbdActive.removeClass("keyboard-active");
							$liSwitchTo.addClass("keyboard-active");
							$liKbdActive = $liSwitchTo;

							if(bMoveForPage)
							{
								$fineDD_ul.scrollTop($fineDD_ul.scrollTop()+$liKbdActive.position().top);
							}
							else if(!checkInView($liKbdActive, $fineDD_ul, false))
							{
								$fineDD_ul.scrollTop($fineDD_ul.scrollTop()+$liKbdActive.position().top-$fineDD_ul.outerHeight()+$liKbdActive.outerHeight());
							}
						}


						break;

					case KEY.RETURN:

						event.preventDefault();
						//alert("ENTER!");

						if($liKbdActive) if($liKbdActive.length)
						{
							QForm.fnInitField_dropdown_selectItem($liKbdActive, $fineDD, $fineDD_li, $fineDD_btn, $fineDD_label, $el, sEmptyMsg);
							$fineDD.absdropdown('hide');
							$fineDD.focus();
						}
						break;

					case KEY.ESC:
						event.preventDefault();
						event.stopImmediatePropagation();
						$fineDD.absdropdown('hide');
						$fineDD.focus();

				}

			});
			// Лечит закртие формы после нажатия на пробел в строке поиска.
			// $fineDD.on('keypress.space-hack click.space-hack', function(e)
			// {
			// 	console.log("type: ", e.type);
			// 	console.dir(e);
			// 	console.log("Result: ", $(e.target.nodeName).is("input:focus"));
			// 	//if($fineDD_inputSearch.is(":focus"))
			// 	if( $(e.target.nodeName).is("input") )
			// 	if( $(e.target.nodeName).is(":focus") && ((e.keyCode == KEY.SPACE) || (e.keyCode == 0))
			// 	|| (e.type == "click") )
			// 	{
			// 		console.log("prevented!");
			// 		e.cancelBubble = true;
			// 		e.stopImmediatePropagation();
			// 		e.preventDefault();
			// 		return false;
			// 	}
			// });


			$el.bind('destroyed', function() // remove when input removed (for example, when form closed)
			{
				$fineDD_ul.remove();
			});

			/**/
			$fineDD.on('shown.bs.dropdown', function()
			{
				if(oOptions.bIsExtended) $fineDD_inputSearch.focus()

				if(!empty($fineDD.data("selected-value")))
				{
					// прокрутим до выбранной записи
					//$fineDD_ul.animate({scrollTop : $fineDD_li.filter(".active").position().top}); //scrollTop();
					$fineDD_ul.scrollTop(
						$fineDD_ul.scrollTop()
						+ $fineDD_li.filter(".active").position().top
						- $fineDD_ul.height()/2 +
						+ $fineDD_li.filter(".active").height()
					);
				}
			});


			$fineDD.toggleClass("empty", empty($el.val())); // Нам это потребуется для того, чтобы показывать незаполненные required-поля.


			// Теперь установим обратную связь. Если кто-то изменил извне, то мы должны изменить и «кнопку»
			$el.change(function()
			{
				var $this = $(this);
				var sVal = $this.val();
				if($this.data("selected-value")!==sVal)
				{
					// пробежимся по всем позициям в списке и выделим соответствующее.
					$fineDD_li.each(function()
					{
						var $this = $(this);
						if($this.data("value")===sVal)
						{   // Нашли!
							QForm.fnInitField_dropdown_selectItem($this, $fineDD, $fineDD_li, $fineDD_btn, $fineDD_label, $el, sEmptyMsg, true); // true means not to call change event
							return; // Выходим из цикла.
						}
					});
				}
			})

		}; // end of if (! (bReadonly||bDisabled))


		var $inputGroup = $el.parent(".input-group").hide();
		var $container = $inputGroup
		   .clone()
		   .show();

		$container.find('select').replaceWith($fineDD);
		$container.insertAfter($inputGroup);

		QForm.fnInitField_dropdown_updateSize($fineDD_btn);

		var arr = $el.attr("name").split("[");
		var sInputTitleName = arr.shift()+"_title"+arr.join("[");

		$el.before('<input name="'+sInputTitleName+'" type="hidden" class="title-for-selected-item" />');
    }
}

QForm.fnInitField_dropdown_selectItem = function($this, $fineDD, $fineDD_li, $fineDD_btn, $fineDD_label, $el, sEmptyMsg, bNotToChange)
{

	var sValue = $this.data('value');
	if(empty(bNotToChange))
	{
		$el.val(sValue); // Устанавливаем значение для select
		$el.change(); // Эта функция вызовет fnInitField_dropdown_selectItem повторно
		              // , но уже с bNotToChange=true;
	}
	else
	{
		$fineDD_li.filter(".active").removeClass("active");
		$fineDD_li.filter(".keyboard-active").removeClass("keyboard-active");
		$this.addClass("active keyboard-active");

		$fineDD.toggleClass("empty", empty(sValue)); // Нам это потребуется для того, чтобы показывать незаполненные required-поля.

		var sTxt = $this.data("label");
		$el.prev("input.title-for-selected-item").val(sTxt); // Устанавливаем значение для поля, в котором будет передаваться текст/заголовок выбранного значения.

		if(!empty(sTxt)) $fineDD_label.html(sTxt);
		else $fineDD_label.html(sEmptyMsg);
		$fineDD.data("selected-label", sTxt);
		$fineDD.data("selected-value", sValue);

		//console.log("btn height:"+$fineDD_btn.height());
		QForm.fnInitField_dropdown_updateSize($fineDD_btn);

		// ↓ уже не нужно (реализовал на уровне CSS с помощью класса empty)
		//$fineDD.toggleClass("invalid", $el.is(":required") && empty(sValue));
	}

}

QForm.fnInitField_dropdown_updateSize = function($fineDD_btn)
{
	setTimeout(function()
	{
		$fineDD_btn.removeClass("small-text").removeClass("smaller-text");

		if($fineDD_btn.find(".choice-label").outerHeight() > 40) $fineDD_btn.addClass("smaller-text");
		else if($fineDD_btn.find(".choice-label").outerHeight() > 28) $fineDD_btn.addClass("small-text");

	}, 50);
}

QForm.fnInitField_int = function($el, oOptions)
{
	this.fnInitField_intdouble($el,oOptions, 0);
}

QForm.fnInitField_double = function($el, oOptions)
{
	this.fnInitField_intdouble($el,oOptions, 1);
}

QForm.fnInitField_slider_postponed = function($el, oOptions)
{
	var $slider_place = $el.parent().prepend('<span style="padding-right: 5px; vertical-align:middle;"><div class="q-slider"></div></span>').find('div.q-slider'); // делаеим относительно parent, чтобы учесть вохможные префиксы.

	$el.width(((oOptions.dMaxVal+'').length+1)*9);

	var $slider = $slider_place.slider
	({
		enabled: (!$el.prop("disabled"))&&(!$el.prop("readonly")),
		range: false,
		value: Number($el.val()),
		min: oOptions.dMinVal,
		max: oOptions.dMaxVal,
		tooltip: 'hide'

	}).on('change', function(e)
	{
		//console.log("changed %o", obj);
		$el.val( e.value.newValue );
		if(!empty(this.iTimeout)) clearTimeout(this.iTimeout);
		this.iTimeout =  setTimeout(function()
		{
			$el.change();
		}, 200);
	});
	this.fnInitField_intdouble($el,oOptions, 0);

	$el.keyup(function(){ $slider.slider( "setValue", Number($el.val()) ); });
	$el.change(function(){ $slider.slider( "setValue", Number($el.val()) ); });

	$(function(){
			var container_width = $('.slider-horizontal').parent().parent();
			var slider_width = container_width.innerWidth() - (parseInt(container_width.find('input').outerWidth(true)) + parseInt(container_width.find('span.input-group-addon').outerWidth(true)));
			container_width.find('span:not(.input-group-addon)').css('width', slider_width+2);
		}
	)

}

QForm.fnInitField_intdouble = function($el,oOptions, bIsFloat)
{
	if(empty(bIsFloat)) bIsFloat = 0;

	/*
	 * Для начала ограничим ввод только числовых значений
	 */
	var oNumericOpts = {};
	if(!bIsFloat) oNumericOpts.decimal = false;
	else oNumericOpts.decimal = ".";
	if(!empty(oOptions.bIsUnsigned)) oNumericOpts.negative = false;
	$el.numeric(oNumericOpts);
	/*
	 * Далее, если это нужно подключим jStepper
	 */
	if(!empty(oOptions.dStepper) && (!$el.prop("disabled")) && (!$el.prop("readonly")))
	{
		var oStepperOpts = {};
		oStepperOpts.decimalSeparator = ".";
		oStepperOpts.normalStep = oOptions.dStepper;
		if(!empty(oOptions.dShiftStep))  oStepperOpts.shiftStep = oOptions.dShiftStep;
		else if(oOptions.dStepper > 5) oOptions.dShiftStep = oStepperOpts.normalStep*2
		if(!empty(oOptions.dCtrlStep))  oStepperOpts.ctrlStep = oOptions.dCtrlStep;
		else if(oOptions.dStepper > 10) oOptions.dCtrlStep = oStepperOpts.normalStep*5
		/****/
		if(oOptions.dMinVal != "" && oOptions.dMinVal != null && oOptions.dMinVal != undefined)  oStepperOpts.minValue = oOptions.dMinVal;
		if(oOptions.dMaxVal != "" && oOptions.dMaxVal != null && oOptions.dMaxVal != undefined)  oStepperOpts.maxValue = oOptions.dMaxVal;
		/***/ // Временно закомментим, т.к. эта штука плохо работает.
		$el.jStepper(oStepperOpts);
	}
};

                            //↓ sEntity
QForm.fnOpenForm = function ( oOptions, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, oOtherPostVars, mTab, bDublicate, fnOnClose)
{

	if(!isNaN(Number(mTab))) var iTab = mTab;
	else  var sTab = mTab;

	if(typeof oOptions == 'object')
	{
		var sEntity = oOptions.sEntity;
		var id = oOptions.id;
		var oExternVars = oOptions.oExternVars;
		var fnOnOpen = oOptions.fnOnOpen;
		var fnOnClose = oOptions.fnOnClose;
		var sFormTitle = oOptions.sFormTitle;
		var sParentEntity = oOptions.sParentEntity;
		var oOtherPostVars = oOptions.oOtherPostVars;
		var iTab = oOptions.iTab;
		var sTab = oOptions.sTab;
		var bDublicate = oOptions.bDublicate;
		var bPrint = oOptions.bPrint;
		var sUrl = oOptions.sUrl;
		var bOpenLeft = oOptions.bOpenLeft ? oOptions.bOpenLeft : false;
	}
	else
	{
		var sEntity = oOptions;
		var bOpenLeft = false;
	}

	if(id === undefined) id = 0;

	if(sParentEntity === undefined) sParentEntity = "usercall";

	if(bPrint === undefined) bPrint = false;
	if(bDublicate === undefined) bDublicate = false;

	var	oParams =
			$.extend(true,
			{
				id: id,
				embeded: 1,
				externvar: oExternVars,
				qparent: sParentEntity,
				dublicate: bDublicate?1:0,
				print: bPrint?1:0
			},
			(oOtherPostVars?oOtherPostVars:{}));

	if(iTab === undefined) iTab = null;
	if(sTab === undefined) sTab = null;

	var sWorkspace = (Q.WORKSPACE.length) ? "/"+Q.WORKSPACE : "";
	var that = this;

	if(empty(sUrl)) sUrl = sWorkspace+"/q/"+sEntity+"/form";
	Q.fnOpenModal
	({
		//sId: "standAlone_"+sEntity+"_FormModal",
		sId: sEntity.split("/").join('_')+"FormModal",//+((Array.isArray(id) && id.length > 1)?"Multiple":id),
		sTitle: sFormTitle,
		sUrl: sUrl,
		oParams: oParams,
		fnOnOpen: fnOnOpen,
		fnOnClose: fnOnClose,
		iTab: iTab,
		sTab: sTab,
		bOpenLeft: bOpenLeft
	});
};



QForm.fnOpenDublForm = function ( sEntity, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, oOtherPostVars, mTab, bDublicate)
{
	QForm.fnOpenForm(sEntity, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, oOtherPostVars, mTab, true);
};


QForm.fnOpenFormOnTab = function(mTab, sEntity, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, oOtherPostVars, bDublicate)
{
	QForm.fnOpenForm(sEntity, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, oOtherPostVars, mTab, bDublicate);
}

							// ↓ sEntity
QForm.fnOpenView = function ( oOptions, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, mTab)
{

	if(typeof oOptions == 'object')
	{
		oOptions.bToPrint = true;
	}
	else
	{
		var sEntity = oOptions;

		oOptions =
		{
		    sEntity:sEntity
		,   id:id
		,   oExternVars:oExternVars
		,   fnOnOpen:fnOnOpen
		,   sFormTitle:sFormTitle
		,   sParentEntity:sParentEntity
		,   bDublicate:false
		,   bPrint:true
		}

		if(!isNaN(Number(mTab))) oOptions.iTab = mTab;
		else  oOptions.sTab = mTab;
	}

	QForm.fnOpenForm(oOptions);
};


QForm.fnOpenViewOnTab = function(iTab, sEntity, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity)
{
	QForm.fnOpenView(sEntity, id , oExternVars, fnOnOpen, sFormTitle, sParentEntity, iTab);
}


QForm.openExternalSelectDialog = function(sElementId, sUrl, sTitle, oExternVars, oParams)
{
	var $el = $("#"+sElementId);
	var sValue = $el.val();

	Q.fnOpenModal
	({
		//sId: "standAlone_"+sEntity+"_FormModal",
		"sId": sElementId+"ExternalSelectModal",
		"sTitle": sTitle,
		"sUrl": sUrl,
		"iWidth": 860, // Временно!! _TODO: сделать это настройкой формы???
		"oParams": $.extend({"externvar": $.extend({"field_domid":sElementId, "field_value":sValue}, oExternVars), "sElementId":sElementId, "sValue":sValue}, oParams),
	});

}


QForm.processMultipleEditControls = function($form)
{
	$form.find("input.qform-multiple-activate-checkbox").not(".processed").tooltip({ placement: "top" }).addClass("processed");
	//console.dir($form.find("input:not(.qform-multiple-activate-checkbox), textarea, select"));

	$form.find("input:not(.qform-multiple-activate-checkbox), textarea, select").not(".processed").each(function()
	{
		if(this.nodeName.toLowerCase() == "select")
			var sOldVal = $(this).val();
		$(this).bind('change keyup',function()
		{
			if(this.nodeName.toLowerCase() == "select")
			{
				var sVal = $(this).val();
				if(sOldVal === sVal) return;
				else sOldVal = sVal;
			}
			$(this).parents(".controls")
				.prev("label.control-label")
				.find("input.qform-multiple-activate-checkbox:not(:checked)")
				.prop("checked", 1);
		});
	}).addClass("processed");
}

QForm.fnThrowStoreError = function(code)
{
	console.dir(code);
	Q.fnAlertError("<h2>Неизвестная ошибка (код: "+code+")</h2><p><b>Внесенные изменения не были сохранены.</b><br>Пожалуйста, обратитесь в службу технической поддержки.</p>");
};


QForm.fnInitField_file = function($el)
{
	var $form = $el.closest("form");
	var iFileSize = parseInt($('input[type=file]').attr('fsize_limit'), 10);
	var iMaxSize = parseInt($('input[type=file]').attr('psize_limit'), 10);
	var sSeparator = "<br>";
	var aSize = Array();
	$form.find($('input[type=file]')).change(function()
	{
		var iFilesSize = 0;
		var iInputsFilesSize = 0;
		var sErrFiles = "";
		$.each($(this)[0].files, function()
		{
			if(typeof $(this).attr("size") !== 'undefined')
			{
				var iSize = $(this).attr("size");
				var sName = $(this).attr("name");
				if(iFileSize < iSize)
				{
					sErrFiles += sName + ": " + conv_size(iSize) + sSeparator;
				};
				iFilesSize += iSize;
	        };
		});
		aSize[$(this)[0].id] = iFilesSize;
		if(sErrFiles)
		{
			Q.fnAlertError("Следующие файлы превышают допустимый размер для загрузки одного файла в " + conv_size(iFileSize) + ":" + sSeparator + sErrFiles
				, $.proxy(function(){$(this).val("");}, this));
			aSize[$(this)[0].id] = 0;
		}
		else if (iFilesSize > iMaxSize)
		{
			Q.fnAlertError("Суммарный объем файлов составляет "+conv_size(iFilesSize)+" и превышает допустимый в "+conv_size(iMaxSize)+sSeparator
				, $.proxy(function(){$(this).val("");}, this));
			aSize[$(this)[0].id] = 0;
		}
		for (var k in aSize)
		{
			iInputsFilesSize += aSize[k];
		};
		if (iInputsFilesSize > iMaxSize)
		{
			Q.fnAlertError("Суммарный объем всех файлов составляет "+conv_size(iInputsFilesSize)+" и превышает допустимый в "+conv_size(iMaxSize)+sSeparator
				, $.proxy(function(){$(this).val("");}, this));
		};
	});
};




//  ХАКИ
// Все функции, чье имя заканчивается на _postponed будут обработаны
// таким образом что при вызове функции без постфикса "_postponed"
// конечная функция будет вызвана только после открытия вкладки, на которой находится элемент

var e;
for(e in QForm)
{
	if(typeof(QForm[e]) === 'function')
	{
		(function(sFn)
		{

			if(e.match(/^fnInitField\_.*\_postponed$/))
			{
				var sFnOriginalName = e.substr(0, sFn.length - "_postponed".length);
				QForm[sFnOriginalName] = function($el, oOptions)
				{
					var $tab = $el.closest('.tab-pane');

					if($tab.is(":visible")) QForm[sFn]($el, oOptions);
					else
					{

						var $EmbList = $el.closest(".EmbededList");
						if($EmbList.length)
						{
							$EmbList.one('initted', function(){ QForm[sFn]($el, oOptions) });
						}
						else
						{
							$el.closest('.tabbable').children().filter('.nav').find('a[data-toggle="tab"]')
										.filter('[href="#'+$tab.attr("id")+'"]')
										.one('shown.bs.tab', function(){ QForm[sFn]($el, oOptions) });
						}
					}
				}
			}
		})(e);
	}
}
